package com.downdogapp.client

/**
 * AUTO-GENERATED DO NOT EDIT!
 * from com.downdogapp.tasks.AppStrings
 */
// @formatter:off 
object PolishStrings : LanguageStrings {
  // https://worker.downdogapp.com/debug/appString?appStringId=488
  override fun ABBREVIATED_MEMBERSHIP_WILL_NOT_RENEW(p0: Any) = "Anulowane, wygasa ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=498
  override val ACCOUNT = "Konto"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2588
  override val ACCOUNT_INELIGIBLE_FOR_REFERRAL_MESSAGE = "Wygląda na to, że masz już konto! Tylko nowe konta kwalifikują się do darmowego członkostwa z polecenia. Przepraszamy!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3956
  override val ACTIVITY = "Aktywność"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1467
  override val AFFILIATE_ANSWER = "Dziękujemy za zainteresowanie! Zrezygnowaliśmy z naszego programu partnerskiego, więc niestety nie. Przepraszamy!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1466
  override val AFFILIATE_QUESTION = "Czy macie program poleceń lub afiliacyjny?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1299
  override val AFFORDABILITY = "Przystępność cenowa"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1300
  override val AFFORDABILITY_FEEDBACK_PROMPT = "Opowiedz nam o swojej sytuacji"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=518
  override val AFFORDABILITY_MESSAGE = "Naszą misją jest zapewnienie świetnej, przystępnej cenowo kondycji na całym świecie. Jeśli Down Dog nie mieści się teraz w Twoim budżecie, wyślij nam wiadomość z wyjaśnieniem swojej sytuacji, a zobaczymy, co możemy zrobić!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3973
  override val AFFORDABILITY_SUPPORT_PAGE_TITLE = "Nie stać Cię na to?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3950
  override val AIRPLAY = "Airplay"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1409
  override val AIRPLAY_ANSWER = "Możesz przesyłać swoją praktykę Down Dog za pomocą AirPlay, korzystając z funkcji dublowania ekranu! Aby uzyskać więcej informacji, przejdź na <a href=\"https://support.apple.com/en-us/HT204289\">stronę wsparcia Apple</a>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1408
  override val AIRPLAY_QUESTION = "Czy obsługujecie AirPlay?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1292
  override val ALL = "Wszystkie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1255
  override val ALL_APPS = "Wszystkie Aplikacje"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1453
  override val ALL_APPS_PURCHASE_ANSWER = "W tym momencie zakupy subskrypcji dają Ci dostęp do wszystkich naszych aplikacji, w tym Down Dog Yoga, HIIT, Barre, Prenatal Yoga i Medytacja!\n\nObecnie nie oferujemy opcji zakupu pojedynczej aplikacji."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1452
  override val ALL_APPS_PURCHASE_QUESTION = "Czy moja subskrypcja dotyczy jednej aplikacji czy wszystkich aplikacji?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3110
  override val ALL_POSES = "Wszystkie Pozycje"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1295
  override fun AMOUNTS_CURRENCY_PAYMENTS_SECURE_MESSAGE(p0: Any) = "Wszystkie kwoty podane w ${p0}. Twoje dane płatności są zaszyfrowane i bezpieczne."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=113
  override val AND = "i"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1589
  override val APPLE = "Apple"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1403
  override val APPLE_HEALTH_ANSWER = "Tak! Jeśli masz problemy z połączeniem, oto kilka wskazówek:\n1. Sprawdź, czy Twoja aplikacja jest połączona z Health. Otwórz aplikację i przejdź do menu (naciśnij przycisk z trzema poziomymi liniami w prawym dolnym rogu), czy jest tam opcja Połącz z Apple Health? Jeśli tak, kliknij tę opcję.\n2. Otwórz aplikację Health na swoim telefonie i kliknij kartę źródeł danych. Czy Down Dog jest wymieniony jako źródło danych? To jest, aby podwójnie sprawdzić, czy Down Dog jest połączony. Jeśli nie jest (ale nie było opcji połączenia w Down Dog), daj nam znać!\n3. Spróbuj odinstalować i ponownie zainstalować aplikację, a następnie zaloguj się i ponownie połącz z Apple Health.\n\nNiestety, Apple Health nie jest obsługiwany na iPadzie i nie obsługujemy śledzenia Twoich praktyk na różnych urządzeniach (chociaż może to się zmienić w przyszłości)."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1402
  override val APPLE_HEALTH_QUESTION = "Czy aplikacje łączą się z Apple Health?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1420
  override fun APPLE_REFUND_POLICY(p0: Any) = "Niestety, Apple nie pozwala nam anulować ani zwracać subskrypcji zakupionych w App Store. Oto instrukcje od Apple, jak anulować subskrypcję: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1425
  override val ASK_IN_FACEBOOK_GROUP = "Zapytaj w grupie na Facebooku"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=490
  override val AUTO_RENEW_IS_OFF = "Automatyczne odnawianie wyłączone"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=489
  override val AUTO_RENEW_IS_ON = "Automatyczne odnawianie włączone"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1221
  override val AUTO_RENEW_OFF_ANSWER = "<b>Jak zarządzać lub anulować subskrypcję</b>\n\nJeśli zakupiłeś subskrypcję <em>na stronie internetowej</em>:\n1. Przejdź do <b>Ustawienia</b>. Na urządzeniach mobilnych możesz tam dotrzeć, stukając trzy poziome linie w prawym dolnym rogu ekranu. Na stronie internetowej, Ustawienia znajdują się w lewym pasku bocznym.\n2. W sekcji <b>Ustawienia</b>, stuknij <b>Subskrypcja</b>.\n3. Następnie powinieneś zobaczyć więcej informacji, w tym jak anulować lub zmienić subskrypcję, w tym wyłączyć automatyczne odnawianie.\n\nJeśli zakupiłeś subskrypcję <em>przez aplikację mobilną</em>, możesz zarządzać swoją subskrypcją przez <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">Apple App Store</a> lub przez <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Google Play Store</a>.\n\n<b>O Twojej subskrypcji</b>\n\nNigdy nie zostaniesz obciążony opłatą za subskrypcję, chyba że wyraźnie zakupisz członkostwo przez naszą stronę internetową, Apple lub Google. Subskrypcje są przypisane do adresu e-mail, którego użyłeś podczas zakupu subskrypcji. Jeśli nie widzisz subskrypcji na swoim koncie, oznacza to, że nie masz subskrypcji powiązanej z adresem e-mail, na który jesteś obecnie zalogowany. Możliwe, że Twoja subskrypcja może być powiązana z innym adresem e-mail, a jeśli tak jest, będziesz musiał się wylogować, a następnie zalogować ponownie przy użyciu tego adresu e-mail, aby zobaczyć swoją subskrypcję."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1211
  override val AUTO_RENEW_OFF_QUESTION = "Chcę wyłączyć automatyczne odnawianie."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=252
  override val BACK = "Wstecz"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=787
  override val BARRE = "Barre"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=759
  override val BARRE_GOOGLE_FIT_DESCRIPTION = "Trening Barre"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1432
  override val BILLING = "Fakturowanie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1258
  override val BILLING_REFUND = "Fakturowanie - zwrot pieniędzy"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=332
  override val BREATHING = "Oddychanie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2538
  override val BREATHING_GOOGLE_FIT_DESCRIPTION = "Ćwiczenia oddechowe"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=263
  override val CANCEL = "Anuluj"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2564
  override val CANCEL_DOWNLOAD = "Anuluj pobieranie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1470
  override val CANNOT_MERGE_ACCOUNTS_ANSWER = "Niestety, nie możemy połączyć Twoich kont.\n\nUpewnij się, że logujesz się za pomocą adresu e-mail, którego użyłeś przy zakupie subskrypcji, aby uzyskać dostęp!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1469
  override val CANNOT_MERGE_ACCOUNTS_QUESTION = "Mam więcej niż jedno konto. Czy mogę je połączyć?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1305
  override val CANT_ACCESS_SUBSCRIPTION_ANSWER = "Prawdopodobnie przypadkowo utworzyłeś wiele kont Down Dog. Spróbuj wylogować się z aplikacji i zalogować ponownie, używając innych adresów e-mail, które mogłeś użyć. Pamiętaj, że Twoja subskrypcja działa we wszystkich naszych aplikacjach i na wszystkich Twoich urządzeniach (w tym w wersji internetowej), ale musisz być zalogowany przy użyciu tego samego adresu e-mail, którego użyłeś do zakupu. <em>Pamiętaj, że Apple, Google i PayPal mogły wysłać potwierdzenia na adres e-mail powiązany z tymi usługami, a nie na adres e-mail, którego użyłeś do logowania się do Down Dog</em>.\n\nJeśli subskrybowałeś z poziomu aplikacji mobilnej za pomocą Apple iTunes lub Google Play, spróbuj kliknąć <b>Przywróć zakup w aplikacji</b> z menu aplikacji. Upewnij się, że robisz to w tej samej aplikacji, w której dokonałeś pierwotnego zakupu.\n\nJeśli subskrybowałeś za pośrednictwem PayPal i nie masz dostępu do swojej subskrypcji, najprawdopodobniej Twoja płatność nie powiodła się. Możesz to sprawdzić w swoim koncie PayPal lub odwiedzając Ustawienia aplikacji, gdzie zobaczysz subskrypcję, która trwa tylko kilka dni. Jeśli tak jest, nie zostałeś faktycznie obciążony i możesz spróbować dokonać zakupu ponownie, odwiedzając naszą stronę internetową. Możesz mieć większe szanse na sukces, płacąc bezpośrednio kartą kredytową, a nie za pomocą PayPal."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1304
  override val CANT_ACCESS_SUBSCRIPTION_QUESTION = "Nie mogę uzyskać dostępu do mojego abonamentu."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3949
  override val CAST = "Przesyłaj"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1203
  override val CAST_ANSWER = "Tak, niedawno dodaliśmy obsługę Chromecast w aplikacjach mobilnych i internetowych!\n\nOto jak korzystać z Chromecast w aplikacji mobilnej:\n1. Upewnij się, że Twoje urządzenie z obsługą Chromecast (takie jak telewizor) jest włączone i znajduje się w tej samej sieci WiFi co Twoje urządzenie z Android/iOS, a także upewnij się, że masz najnowszą wersję aplikacji.\n2. Rozpocznij praktykę.\n3. Dotknij ekranu, aby wywołać kontrolki, a następnie dotknij <b>przycisku Chromecast</b> w prawym górnym rogu (wygląda jak prostokąt z trzema ćwierćkolami w dolnym rogu).\n4. Poczekaj do minuty, aż praktyka załaduje się na Twoim telewizorze, a następnie kliknij odtwarzanie na swoim urządzeniu z Android/iOS.\n\nA oto jak korzystać z Chromecast w aplikacji internetowej:\n1. Upewnij się, że Twoje urządzenie z obsługą Chromecast (takie jak telewizor) jest włączone i znajduje się w tej samej sieci WiFi co Twój komputer.\n2. Rozpocznij praktykę w aplikacji internetowej, używając <b>Chrome</b>.\n3. Kliknij <b>przycisk Chromecast</b> w prawym dolnym rogu (wygląda jak prostokąt z trzema ćwierćkolami w dolnym rogu).\n4. Poczekaj do minuty, aż praktyka załaduje się na Twoim telewizorze, a następnie kliknij odtwarzanie na swoim komputerze."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1191
  override val CAST_QUESTION = "Czy obsługujecie Chromecast?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1349
  override val CAST_TROUBLESHOOTING_ANSWER = "<b>Jeśli przycisk CAST nie pojawia się:</b> \n\n1. Rozpocznij praktykę, a następnie wstrzymaj. Czy widzisz przycisk cast (w prawym górnym rogu dla Android/iOS; w prawym dolnym rogu dla aplikacji webowej)? Przycisk cast pojawia się tylko podczas praktyki. \n\n2. Spróbuj przesłać coś innego (np. YouTube) z tego samego urządzenia. Czy wtedy widzisz przycisk cast? Jeśli nie, upewnij się, że Twoje urządzenie z funkcją Chromecast (np. telewizor) jest włączone i znajduje się w tej samej sieci WiFi co Twój komputer lub urządzenie Android/iOS. Jeśli korzystasz z komputera, upewnij się, że używasz przeglądarki Chrome. \n\n3. Spróbuj przesłać z innego urządzenia. Jeśli używałeś Android/iOS, spróbuj przesłać z aplikacji webowej na komputerze i odwrotnie. \n\n4. Spróbuj wyłączyć optymalizację baterii dla aplikacji Down Dog na swoim telefonie. To pozwoli aplikacji na ciągłą komunikację z urządzeniem Chromecast, zamiast przechodzić w tryb oszczędzania energii po kilku minutach bezczynności. \n\n\n<b>Jeśli jesteś \"POŁĄCZONY\", ale wideo się nie odtwarza:</b> \n\nNajpierw upewnij się, że czekasz wystarczająco długo, aby Down Dog załadował się na Twoim telewizorze. Ładowanie może potrwać do 60 sekund. W tym czasie Twój telewizor początkowo pokaże żółty pasek \"ładowania\" na dole, a następnie zniknie. Twój telewizor pokaże wideo, gdy tylko zakończy się ładowanie. \n\nJeśli ekran telewizora jest nadal czarny po 60 sekundach lub jeśli słowa \"Down Dog\" pojawiają się na środku czarnego ekranu, zakończ praktykę i spróbuj ponownie. Możesz ponownie uruchomić tę samą praktykę z zakładki Historia (ikona zegara na dole ekranu dla Android/iOS; w lewym pasku bocznym dla aplikacji webowej). \n\n\n<b>Jeśli połączenie cast rozłącza się po kilku minutach odtwarzania:</b> \n\n1. Sprawdź siłę sygnału WiFi. Jeśli Twój Chromecast lub telefon/komputer ma słaby sygnał, możesz poprawić siłę sygnału za pomocą wzmacniacza WiFi lub przesuwając go bliżej routera.\n\n2. Wyłącz optymalizację baterii dla aplikacji Down Dog na swoim telefonie. To pozwoli aplikacji na ciągłą komunikację z urządzeniem Chromecast, zamiast przechodzić w tryb oszczędzania energii po kilku minutach bezczynności. \n\n3. Jeśli to nie rozwiąże problemu, spróbuj ponownie uruchomić router.\n\n4. Na koniec spróbuj edytować ustawienia zapisanej sieci WiFi w telefonie, aby używać statycznego adresu IP."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1348
  override val CAST_TROUBLESHOOTING_QUESTION = "Mam problem z Chromecastem."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=997
  override fun CASTING_TO_DEVICE(p0: Any) = "Rzucanie do ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3302
  override val CHALLENGE_EMAIL_NOTIFICATIONS_TEXT = "E-mail"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3470
  override val CHALLENGE_EMAIL_UPDATES_TEXT = "E-mail"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3468
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBHEADER = "Aktualizacje Wyzwania"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3469
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBTEXT = "Otrzymuj aktualizacje dotyczące społeczności i postępów w wyzwaniu!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3466
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBHEADER = "Codzienne Przypomnienia"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3467
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBTEXT = "Otrzymuj przypomnienia o codziennej praktyce w styczniu!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3809
  override val CHALLENGE_FAQ_A1 = "A: Aby ukończyć wyzwanie, musisz codziennie w ciągu miesiąca ukończyć jedną praktykę. Możesz używać dowolnej aplikacji Down Dog. Praktyki muszą być ukończone w całości."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3811
  override val CHALLENGE_FAQ_A2 = "O: Down Dog będzie śledzić Twój postęp za pomocą kalendarza na stronie Podróży w Twojej aplikacji! Każdego dnia, gdy ćwiczysz i widzisz datę w kalendarzu na niebiesko, jest to zaliczane do Twojego postępu w wyzwaniu."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3814
  override val CHALLENGE_FAQ_A3 = "O: Wysyłamy nasze codzienne przypomnienia na podstawie godziny, o której ćwiczyłeś dzień wcześniej. Więc jeśli ćwiczyłeś wcześniej niż zwykle, mogłeś nas wyprzedzić! Dopóki widzisz swoje praktyki śledzone w kalendarzu na stronie Twojej Podróży, są one zaliczane do postępów w wyzwaniu."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3816
  override val CHALLENGE_FAQ_A4 = "O: Nie. Bardzo nam przykro, ale nie możemy dodać praktyk do Twojej historii, które nie zostały ukończone w aplikacji Down Dog."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3818
  override val CHALLENGE_FAQ_A5 = "O: Jeśli podróżujesz i zmieniasz strefy czasowe, może to wpłynąć na Twoją serię wyzwań. Obecnie nasz system rejestruje historię Twojej praktyki na podstawie strefy czasowej, w której się znajdujesz w momencie praktyki. Oznacza to, że daty Twojej praktyki będą zgodne z Twoją obecną strefą czasową, a nie z pierwotną. Aby utrzymać swoją serię, zalecamy praktykowanie o czasie, który odpowiada Twojej pierwotnej strefie czasowej, gdy tylko jest to możliwe."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3820
  override val CHALLENGE_FAQ_A6 = "O: Zwycięzcy są wybierani losowo z grupy użytkowników, którzy ukończą wyzwanie. Zwycięzcy są kontaktowani indywidualnie na koniec wyzwania."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3808
  override val CHALLENGE_FAQ_Q1 = "P: Jakie są wymagania?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3810
  override val CHALLENGE_FAQ_Q2 = "P: Jak śledzony jest mój postęp?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3813
  override val CHALLENGE_FAQ_Q3 = "P: Zarejestrowałem się do codziennych powiadomień, ale dzisiaj nie otrzymałem żadnego, czy coś jest nie tak?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3815
  override val CHALLENGE_FAQ_Q4 = "P: Ukończyłem praktykę gdzie indziej - czy można ją dodać do mojej historii w aplikacji?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3817
  override val CHALLENGE_FAQ_Q5 = "P: Podróżuję w trakcie wyzwania. Czy to wpłynie na coś?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3819
  override val CHALLENGE_FAQ_Q6 = "P: Jak wybierani i kontaktowani są zwycięzcy nagród?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3807
  override val CHALLENGE_FAQ_TITLE = "FAQ dotyczące wyzwania Down Dog"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3465
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TEXT = "Zdecydowałeś się nie otrzymywać żadnych komunikatów, więc nie będziesz otrzymywać żadnych aktualizacji postępów ani przypomnień od Down Dog dotyczących wyzwania."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3471
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TITLE = "Czy jesteś pewien?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3303
  override val CHALLENGE_PUSH_NOTIFICATIONS_TEXT = "Powiadomienia push"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3317
  override val CHALLENGE_RESUBSCRIBE_TO_EMAILS_ALERT_TEXT = "Uwaga! Wcześniej zrezygnowałeś z otrzymywania wiadomości e-mail od Down Dog. Włączając komunikację e-mail w ramach wyzwania, automatycznie ponownie włączymy Twoje konto do otrzymywania wiadomości e-mail od nas."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1218
  override val CHANGE_EMAIL_ANSWER = "1. Przejdź do <b>Ustawienia</b>. Na urządzeniach mobilnych możesz tam dotrzeć, stukając trzy poziome linie w prawym dolnym rogu ekranu. W wersji internetowej Ustawienia znajdują się w lewym pasku bocznym.\n2. W sekcji <b>Konto</b> stuknij <b>Email</b> i wprowadź adres email, którego chcesz używać.\n3. Stuknij <b>Zapisz</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1208
  override val CHANGE_EMAIL_QUESTION = "Jak mogę zmienić adres e-mail powiązany z moim kontem?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=152
  override val CHANGE_LANGUAGE = "Zmień język"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1159
  override val CHANGE_LANGUAGE_ANSWER = "<b>Joga, Prenatalna, Medytacja, HIIT</b>\n\nMożesz zmienić język, przechodząc do <b>Ustawienia</b> (w aplikacji mobilnej, stuknij 3 poziome linie w prawym dolnym rogu, a w aplikacji internetowej Ustawienia będą na lewym pasku bocznym), a następnie stuknij <b>Język</b>!\n\n<b>Barre</b>\n\nObecnie ta aplikacja jest dostępna tylko w języku angielskim. Nadal będziesz słyszeć instrukcje w języku angielskim, nawet po zmianie języka."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=327
  override val CHANGE_LANGUAGE_NO_INTERNET_MESSAGE = "Ojej! Musisz być połączony z internetem, aby zmienić język."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1158
  override val CHANGE_LANGUAGE_QUESTION = "Jak zmienić język, który słyszę?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1219
  override val CHANGE_PASSWORD_ANSWER = "1. Przejdź do <b>Ustawienia</b>. Na urządzeniach mobilnych możesz tam dotrzeć, stukając trzy poziome linie w prawym dolnym rogu ekranu. W wersji internetowej, Ustawienia znajdują się w lewym pasku bocznym.\n2. W sekcji <b>Konto</b>, stuknij <b>Hasło</b> i wypełnij nowe hasło, którego chcesz używać, w polach Hasło i Potwierdź Hasło.\n3. Stuknij <b>Zapisz</b>.\n\nJeśli zapomniałeś hasła, po prostu wprowadź swój email i nieprawidłowe hasło na ekranie logowania. Następnie kliknij opcję <b>Zapomniałeś hasła?</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1209
  override val CHANGE_PASSWORD_QUESTION = "Jak zmienić hasło?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1142
  override val CHANGE_PLAYLIST_TYPE_ANSWER = "Oferujemy wiele kategorii muzyki i stale dodajemy nowe opcje! W aplikacji możesz zmienić styl muzyki, przesuwając widok ustawień w górę i stukając <b>Muzyka</b>! W wersji internetowej możesz przewijać ustawienia i kliknąć opcję <b>Muzyka</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1141
  override val CHANGE_PLAYLIST_TYPE_QUESTION = "Jak zmienić muzykę?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=52
  override val CHANGE_VISUAL_TYPE_NO_INTERNET_MESSAGE = "Oj! Będziesz potrzebować połączenia z internetem, aby zmienić wizualizacje dla tej praktyki."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1157
  override val CHANGE_VOICE_ANSWER = "<b>Joga, Prenatalna, Medytacja i HIIT</b>\n\nObecnie oferujemy wiele głosów mówiących po angielsku w tych aplikacjach. Na urządzeniach mobilnych możesz zmienić głos, który słyszysz, przesuwając w górę na głównej stronie ustawień, a następnie stukając w <b>Głos</b>. W wersji internetowej możesz przewinąć ustawienia i kliknąć opcję <b>Głos</b>.\n\nOferujemy również kilka głosów mówiących w innych językach w tych aplikacjach. Możesz zmienić język, przechodząc do <b>Ustawienia</b> (w aplikacji mobilnej stuknij 3 poziome linie w prawym dolnym rogu, a w aplikacji internetowej Ustawienia będą na lewym pasku bocznym), a następnie stuknij <b>Język</b>!\n\n<b>Barre</b>\n\nNa razie jest tylko jeden głos, ale planujemy dodać dodatkowe języki i głosy w przyszłości."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1156
  override val CHANGE_VOICE_QUESTION = "Jak mogę zmienić głos, który słyszę?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1441
  override val CHARGED_TWICE = "Zostałem obciążony dwukrotnie."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1433
  override fun CHECK_OUT_QUESTION(p0: Any) = "Sprawdź naszą ${p0}, aby zobaczyć, czy Twoje pytanie zostało tam odpowiedziane"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=482
  override val CLEAR_PRACTICE_HISTORY_CONFIRM_MESSAGE = "Czy na pewno chcesz usunąć wszystkie ćwiczenia z historii ćwiczeń? Tej operacji nie można cofnąć."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=275
  override val CLOSE = "Zamknij"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1180
  override val COMMUNITY_ANSWER = "Mamy tętniącą życiem i wspierającą <a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\">Społeczność Down Dog</a> na Facebooku, do której możesz dołączyć, aby poprosić o radę i podzielić się swoimi postępami! Możesz również śledzić nas na <a href=\"https://www.instagram.com/downdogapp/\" target=\"_blank\">Instagramie</a>, aby uzyskać wskazówki i połączyć się z innymi, którzy ćwiczą z Down Dog!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1172
  override val COMMUNITY_QUESTION = "Pragnę społeczności podczas mojej podróży! Czy jest jakaś grupa, do której mogę dołączyć, aby uzyskać wsparcie, gdy mam pytania?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1394
  override val COMPANIES_FREE_UNTIL_JUNE_1_LONG = "Pracownicy pracujący zdalnie są uprawnieni do bezpłatnego członkostwa do 1 czerwca!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2563
  override val CONFIRM_CANCEL_OFFLINE_DOWNLOAD = "Czy na pewno chcesz anulować to pobieranie?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2561
  override val CONFIRM_DELETE_OFFLINE_PRACTICE = "Czy na pewno chcesz usunąć tę sesję ćwiczeń offline?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=428
  override val CONFIRM_PASSWORD = "Potwierdź hasło"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1
  override val CONNECT_TO_APPLE_HEALTH = "Połącz z Apple Health"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=93
  override val CONNECT_TO_GOOGLE_FIT = "Połącz z Google Fit"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2
  override val CONNECTED_TO_APPLE_HEALTH_MESSAGE = "Twoje ćwiczenia będą teraz automatycznie rejestrowane w Apple Health!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=94
  override val CONNECTED_TO_GOOGLE_FIT_MESSAGE = "Twoje ćwiczenia będą teraz automatycznie rejestrowane w Google Fit!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1009
  override val CONNECTING_TO_CHROMECAST = "Łączenie..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=25
  override val CONNECTION_PROBLEM = "Problem z połączeniem"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=264
  override val CONTACT = "Skontaktuj się"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1421
  override val CONTACT_APPLE_FOR_REFUND = "Jeśli chcesz otrzymać zwrot pieniędzy, skontaktuj się z pomocą techniczną Apple i poinformuj ich, że zgadzamy się na zwrot."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=265
  override val CONTINUE = "Kontynuuj"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=437
  override val CORPORATE_MEMBERSHIP = "Członkostwo Korporacyjne"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=616
  override val COUNTDOWN_TIMER = "Licznik czasu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2550
  override val CREATE_OFFLINE_PRACTICE = "Utwórz Ćwiczenia Offline"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2562
  override val CREATE_OFFLINE_PRACTICE_EXPLANATION = "Utwórz i pobierz praktykę z bieżącymi ustawieniami?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1604
  override val CUSTOM = "Niestandardowy"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=266
  override val DELETE = "Usuń"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=399
  override val DELETE_ACCOUNT = "Usuń konto"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=487
  override val DELETE_ACCOUNT_AND_STOP_PAYMENTS_CONFIRM_MESSAGE = "Twoje konto zostanie TRWALE usunięte ze WSZYSTKICH aplikacji Down Dog, a my automatycznie anulujemy Twoją subskrypcję. Kontynuować?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1220
  override val DELETE_ACCOUNT_ANSWER = "Jeśli zdecydujesz się nas opuścić, możesz usunąć swoje konto w aplikacji mobilnej lub w aplikacji internetowej. Pamiętaj, że po usunięciu konta stracisz swoją płatną subskrypcję, historię oraz zapisane praktyki i nie będzie można ich przywrócić!\n\n1. Przejdź do <b>Ustawienia</b>. W aplikacji mobilnej możesz tam dotrzeć, stukając trzy poziome linie w prawym dolnym rogu ekranu. W aplikacji internetowej Ustawienia znajdują się w lewym pasku bocznym.\n2. W sekcji <b>Ustawienia</b> przewiń w dół do <b>Moje dane</b> i stuknij <b>Usuń konto</b>.\n3. Gdy pojawi się okno dialogowe, stuknij <b>OK</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=485
  override val DELETE_ACCOUNT_CONFIRM_MESSAGE = "Czy na pewno chcesz usunąć swoje konto? Tej akcji nie można cofnąć. Twoje konto zostanie trwale usunięte ze wszystkich aplikacji Down Dog."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1210
  override val DELETE_ACCOUNT_QUESTION = "Jak usunąć swoje konto?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1556
  override val DELETE_ACCOUNT_RECONFIRM_MESSAGE = "Zaraz trwale usuniesz swoje konto we WSZYSTKICH aplikacjach Down Dog. TEJ AKCJI NIE MOŻNA COFNĄĆ. Czy chcesz kontynuować?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=486
  override val DELETE_ACCOUNT_WITHOUT_STOPPING_PAYMENTS_CONFIRM_MESSAGE = "Twoje konto zostanie trwale usunięte ze WSZYSTKICH aplikacji Down Dog. Nadal BĘDZIESZ OBCIĄŻANY opłatą za subskrypcję, dopóki jej nie anulujesz. Kontynuować?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=467
  override val DELETE_HISTORY = "Wyczyść historię ćwiczeń"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2565
  override val DELETE_OFFLINE_PRACTICE = "Usuń ćwiczenia offline"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1351
  override val DEVICE_LIMIT_ANSWER = "Tak! Upewnij się, że używasz tego samego adresu e-mail do logowania, którego użyłeś podczas subskrypcji."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1306
  override val DEVICE_LIMIT_QUESTION = "Czy moja subskrypcja daje mi dostęp do treningów na wszystkich moich urządzeniach (laptopie, telefonie, tablecie itp.)?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1501
  override val DIDNT_PURCHASE_SUBSCRIPTION = "Nie wykupiłeś subskrypcji."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3946
  override val DISLIKE = "Nie lubię tego"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1502
  override val DONT_SEE_SUBSCRIPTION = "Nie widzę mojej subskrypcji"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=629
  override val DOWNLOAD = "Pobierz"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2557
  override val DOWNLOAD_EXPLANATION = "Możesz znaleźć tę praktykę na stronie Praktyki Offline po zakończeniu pobierania."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2559
  override val DOWNLOAD_PRACTICE = "Pobierz Ćwiczenia"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2556
  override val DOWNLOAD_STARTED = "Pobieranie rozpoczęte"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2555
  override fun DOWNLOADING_VIDEO_PROGRESS(p0: Any) = "Pobieranie... ${p0}%"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3947
  override val EDIT = "Edytuj"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=491
  override val EDIT_EMAIL = "Edytuj e-mail"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=628
  override val EDIT_NAME = "Edytuj nazwę"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=492
  override val EDIT_PASSWORD = "Edytuj hasło"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=462
  override val EMAIL = "E-mail"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=137
  override val EMAIL_AND_PASSWORD = "Email i Hasło"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=197
  override val ENGLISH_POSE_NAMES = "Nazwy pozycji w języku angielskim"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3370
  override fun ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_INSTRUCTIONS(p0: Any) = "1. Otwórz aplikację Ustawienia.\n\n2. Przejdź do Powiadomienia.\n\n3. Znajdź aplikację ${p0} i upewnij się, że <b>powiadomienia są włączone.</b>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3304
  override val ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_PROMPT = "Upewnij się, że masz włączone powiadomienia push dla Down Dog na swoich urządzeniach mobilnych."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=146
  override val ENTER_CODE = "Wprowadź kod"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=138
  override val ENTER_EMAIL_ADDRESS = "Wprowadź adres e-mail"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=139
  override val ENTER_PASSWORD = "Wprowadź hasło"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2170
  override val EQUIPMENT = "Sprzęt"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=88
  override val ERROR_CONNECTING_TO_APPLE_HEALTH_MESSAGE = "Oj! Wystąpił błąd podczas łączenia z aplikacją Zdrowie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=56
  override val ERROR_CONNECTING_TO_GOOGLE_FIT_MESSAGE = "O nie! Wystąpił błąd podczas łączenia z Google Fit."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=57
  override val ERROR_OCCURRED_MESSAGE = "Wystąpił błąd. Prosimy o kontakt z nami w celu uzyskania wsparcia."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1198
  override val EXCLUDE_POSES_ANSWER = "<b>Joga</b>\n\nTak! W pełnych ustawieniach, w sekcji Praktyka, dotknij <b>Wyświetl Pozycje</b>. Stąd możesz \"nie lubić\" pozycji, a one zostaną wykluczone z przyszłych praktyk.\n\nNa stronie <b>Wyświetl Pozycje</b> możesz również \"lubić\" wybrane pozycje, co zwiększy prawdopodobieństwo, że pojawią się one w przyszłych praktykach.\n\nProszę zauważyć, że funkcja Liked and Excluded poses jest dostępna tylko dla nowych typów praktyk: Vinyasa, Restorative, Yin, Gentle i Hatha. Starsze typy praktyk nie obsługują tej funkcji.\n\nProszę również zauważyć, że lubienie/nie lubienie pozycji wpłynie na różnorodność.\n\n<b>HIIT</b>\n\nTak! W sekcji Praktyka, dotknij <b>Mix</b>. Następnie dotknij + po lewej stronie każdej części ciała, a pojawi się lista ćwiczeń. Dotknij konkretnych ćwiczeń, które chcesz wykluczyć z praktyki.\n\n<b>Przedporodowa, Barre</b>\n\nObecnie nie mamy tej funkcji, ale jest ona na naszej liście! Na razie, w aplikacji mobilnej, możesz pominąć każdą pozycję, której nie lubisz, przesuwając w lewo, gdy się pojawi. W aplikacji internetowej kliknij strzałkę do przodu w lewym dolnym rogu ekranu."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1187
  override val EXCLUDE_POSES_QUESTION = "Czy mogę wykluczyć poszczególne pozycje z mojej praktyki?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1262
  override val EXERCISE_ADVICE = "Porady dotyczące ćwiczeń"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1602
  override val EXERCISE_LIST = "Lista Ćwiczeń"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3254
  override val EXERCISE_NAMES = "Nazwy Ćwiczeń"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=267
  override val EXIT = "Wyjdź"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=268
  override val EXIT_PRACTICE = "Zakończ ćwiczenie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=156
  override val EXIT_PRACTICE_MESSAGE = "Czy na pewno chcesz opuścić swoją obecną praktykę?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2720
  override val EXPLICIT_LYRICS = "Wulgarny język"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=280
  override val FACEBOOK = "Facebook"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=58
  override val FACEBOOK_AUTHENTICATION_FAILURE_MESSAGE = "Błąd uwierzytelniania Facebook. Proszę spróbować ponownie później."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=147
  override val FACEBOOK_COMMUNITY = "Społeczność na Facebooku"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2552
  override val FAILED_PRACTICE_DOWNLOAD = "Nie udało się pobrać ćwiczenia"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2568
  override val FAILED_PRACTICE_DOWNLOAD_EXPLANATION = "Coś poszło nie tak podczas pobierania tej praktyki. Proszę spróbuj ponownie."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1308
  override val FAMILY_SHARING_ANSWER = "Niestety, nie obsługujemy Apple Family Sharing."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1307
  override val FAMILY_SHARING_QUESTION = "Czy mogę udostępnić moją subskrypcję członkom rodziny?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1434
  override val FAQ_PAGE = "Strona FAQ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=269
  override val FAVORITE = "Dodaj do ulubionych"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=278
  override val FAVORITES = "Ulubione"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1261
  override val FEATURE_REQUEST = "Prośba o funkcję"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2153
  override val FEEDBACK_OPTIONAL = "Opinie (opcjonalnie)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1274
  override val FEEDBACK_SUBMITTED_TEXT = "Dziękujemy za wiadomość!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2553
  override val FETCHING_PRACTICE = "Tworzenie praktyki..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1417
  override val FITBIT_ANSWER = "Nie."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1416
  override val FITBIT_QUESTION = "Czy aplikacje łączą się z FitBit?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3957
  override val FOR_YOU = "Dla Ciebie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=140
  override val FORGOT_PASSWORD = "Zapomniałeś hasła?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=461
  override val FORGOT_PASSWORD_NEEDS_EMAIL = "Najpierw wprowadź swój adres e-mail, aby zresetować hasło."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1291
  override val FREE_FOR_HEALTHCARE_WORKERS = "Bezpłatnie dla pracowników służby zdrowia"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1110
  override val FREE_FOR_SCHOOLS = "Darmowe dla szkół"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1395
  override val GET_COMPANIES_MEMBERSHIP = "Uzyskaj bezpłatne członkostwo korporacyjne"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1393
  override val GET_HEALTHCARE_MEMBERSHIP = "Uzyskaj członkostwo w opiece zdrowotnej"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1392
  override val GET_STUDENT_MEMBERSHIP = "Uzyskaj członkostwo studenckie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1463
  override val GIFT_ANSWER = "Nie. Obecnie tego nie oferujemy."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3823
  override val GIFT_INSTRUCTIONS_CONTENT_1 = "Kup swój prezent Down Dog (lub prezenty!)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3824
  override val GIFT_INSTRUCTIONS_CONTENT_2 = "Otrzymaj certyfikat upominkowy, który możesz wydrukować lub wysłać do swoich przyjaciół i rodziny."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3825
  override val GIFT_INSTRUCTIONS_CONTENT_3 = "Odbiorcy mogą użyć kodu QR w swoim Certyfikacie, aby rozpocząć roczny dostęp, kiedy tylko będą gotowi!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3780
  override val GIFT_INSTRUCTIONS_TITLE = "Jak to działa:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1462
  override val GIFT_QUESTION = "Czy mogę podarować subskrypcję?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1440
  override val GO_TO_APPLE_SUPPORT = "Przejdź do Apple Support"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1519
  override val GOAL_STREAK_CAPITALIZED = "Seria Celów"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1514
  override val GOAL_STREAK_NOT_CAPITALIZED = "Seria celów"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=281
  override val GOOGLE = "Google"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=60
  override val GOOGLE_AUTHENTICATION_FAILURE_MESSAGE = "Błąd uwierzytelniania Google. Proszę spróbować ponownie później."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1401
  override val GOOGLE_FIT_ANSWER = "Niestety, nie wspieramy już Google Fit.\n\nGoogle wprowadził pewne zmiany, które sprawiły, że bardzo trudno było nadal integrować Google Fit z naszymi usługami."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1400
  override val GOOGLE_FIT_QUESTION = "Czy aplikacje łączą się z Google Fit?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1495
  override val GUIDED_MEDITATION_AND_BREATHING_ANSWER = "<b>Joga:</b>\n\n<em>Spróbuj Yoga Nidra</em>\n\nMożesz znaleźć <b>Yoga Nidra</b> w aplikacji Joga w sekcji <b>Typ</b> praktyki.\n\nUwaga: Yoga Nidra to <b>tylko audio</b> - nie będzie wideo.\n\nWiele osób lubi ustawiać <b>Muzykę</b> na Dźwięki Natury, Ambient, Fale Mózgowe lub Fortepian i Struny w aplikacji. Wypróbuj kilka i zobacz, który preferujesz!\n\nJeśli jesteś nowy w Yoga Nidra, zalecamy słuchanie jej z ustawionym <b>Typem Instrukcji</b> na <b>Pełne Wyjaśnienie</b> lub <b>Domyślne</b>.\n\nMożesz również użyć Yoga Nidra, aby zasnąć. Po wybraniu Yoga Nidra jako Typu praktyki, przejdź do <b>Wzmocnienia</b> i stuknij <b>Sen</b>!\n\n\n<b>Joga Prenatalna:</b>\n\nUstaw swoje <b>Wzmocnienie</b> na <b>Oddychanie</b>! To zapewni ci kilka ćwiczeń oddechowych na początku praktyki, a także medytację prowadzoną na końcu!\n\n\n<b>Medytacja:</b>\n\nMamy całą aplikację poświęconą medytacji i oddychaniu! Sprawdź ją na <a href='https://meditation.downdogapp.com/download'>Medytacja</a>!\n\nJeśli jesteś nowy w medytacji, aby otrzymać najwięcej instrukcji, przesuń widok ustawień w górę i ustaw <b>Ilość Przewodnictwa</b> na <b>Najwięcej</b>, a <b>Najdłuższą Ciszę</b> na krótki czas, jak 30 sekund lub 1 minuta."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1494
  override val GUIDED_MEDITATION_AND_BREATHING_QUESTION = "Jak mogę dodać więcej ćwiczeń oddechowych i medytacji prowadzonej do mojej praktyki?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=95
  override val HEALTH_DISCLAIMER_AND_WARNING = "Zrzeczenie się odpowiedzialności zdrowotnej i ostrzeżenie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=97
  override val HEALTH_WAIVER_TEXT = "* Yoga Buddhi Co. oferuje informacje dotyczące zdrowia i fitnessu przeznaczone wyłącznie do celów edukacyjnych. Nie powinieneś polegać na informacjach zawartych w jakiejkolwiek Aplikacji stworzonej przez Yoga Buddhi Co. (w tym, ale nie wyłącznie, aplikacjach na komputery, urządzenia mobilne i inne urządzenia, stronach internetowych, blogach oraz wszelkich stronach w mediach społecznościowych prowadzonych przez Yoga Buddhi Co. lub Down Dog) jako zamienniku profesjonalnej porady medycznej, diagnozy lub leczenia. W żaden sposób nie gwarantujemy ani nie ręczymy za dokładność, kompletność lub przydatność jakiejkolwiek treści znalezionej w jakiejkolwiek Aplikacji. Korzystanie z jakichkolwiek informacji dostarczonych w tej lub jakiejkolwiek innej Aplikacji stworzonej przez Yoga Buddhi Co. odbywa się wyłącznie na własne ryzyko. Nie ponosimy odpowiedzialności za urazy doznane podczas praktykowania tych technik, a Yoga Buddhi Co. nie ponosi odpowiedzialności za jakiekolwiek szkody, okoliczności, warunki lub urazy, które mogą wystąpić bezpośrednio lub pośrednio w wyniku angażowania się w jakiekolwiek działania lub pomysły przedstawione w jakiejkolwiek Aplikacji stworzonej przez Yoga Buddhi Co. Praktykowanie jogi wiąże się z ryzykiem urazu. Nie zalecamy ćwiczeń jogi bez odpowiedniego nadzoru, jeśli jesteś w ciąży lub masz mniej niż 18 lat. Korzystając z jakiejkolwiek Aplikacji, akceptujesz pełną odpowiedzialność za swoje zdrowie i wszelkie wynikłe urazy lub wypadki, które mogą wpłynąć na twoje samopoczucie lub zdrowie i/lub zdrowie twojego dziecka w jakikolwiek sposób. Skonsultuj się z lekarzem lub dostawcą opieki zdrowotnej przed rozpoczęciem jakiegokolwiek programu fitness, lub jeśli masz jakiekolwiek pytania lub wątpliwości dotyczące swojego zdrowia. Nie rozpoczynaj programu fitness, jeśli twój lekarz lub dostawca opieki zdrowotnej odradza to. Jeśli w trakcie ćwiczeń doświadczysz omdlenia, zawrotów głowy, bólu lub duszności, powinieneś natychmiast przerwać i natychmiast zasięgnąć pomocy medycznej."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1391
  override val HEALTHCARE_FREE_UNTIL_JANUARY_1_LONG = "Pracownicy służby zdrowia są uprawnieni do bezpłatnego członkostwa do 1 czerwca 2022 roku!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1459
  override val HEALTHCARE_MEMBERSHIPS = "Członkostwa w opiece zdrowotnej"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1753
  override val HERE_ARE_YOUR_SETTINGS = "Oto twoje ustawienia!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=785
  override val HIIT = "HIIT"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=758
  override val HIIT_GOOGLE_FIT_DESCRIPTION = "Trening interwałowy"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=282
  override val HISTORY = "Historia"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1517
  override fun HOURS_SHORT(p0: Any) = "${p0} godz."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1176
  override val HOW_MANY_INTRO_LESSONS_ANSWER = "W naszym wprowadzeniu jest łącznie 9 lekcji!\n\nJeśli dotkniesz <b>Typ</b>, zobaczysz 3 kategorie: Vinyasa, Hatha i Restorative.\n\nNastępnie, po wybraniu <b>Typu</b>, dotknij numeru (<b>1, 2 lub 3</b>), aby wykonać odpowiednią lekcję. Numerowane lekcje są zaprojektowane tak, aby budować na sobie nawzajem, więc zalecamy rozpoczęcie od 1. Jeśli kółko ma białe tło, to jest to wybrana lekcja tego Typu."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1168
  override val HOW_MANY_INTRO_LESSONS_QUESTION = "Ile jest lekcji wprowadzających?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1475
  override val HOW_TO_CANCEL_ANSWER = "<b>Jak zarządzać lub anulować subskrypcję</b>\n\n<em>Jeśli zakupiłeś subskrypcję na stronie internetowej</em>:\n\n1. Przejdź do <b>Ustawienia</b>. Na urządzeniu mobilnym możesz tam dotrzeć, stukając trzy poziome linie w prawym dolnym rogu ekranu. Na stronie internetowej, Ustawienia znajdują się w lewym pasku bocznym.\n2. W sekcji <b>Ustawienia</b>, stuknij <b>Subskrypcja</b>.\n3. Następnie powinieneś zobaczyć więcej informacji, w tym jak anulować lub zmienić subskrypcję, w tym wyłączenie automatycznego odnawiania.\n\n<em>Jeśli zakupiłeś subskrypcję przez aplikację mobilną</em>:\n\nMożesz zarządzać swoją subskrypcją przez <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">Apple App Store</a> lub przez <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Google Play Store</a>.\n\n<b>O Twojej subskrypcji</b>\n\nNigdy nie zostaniesz obciążony opłatą za subskrypcję, chyba że wyraźnie zakupisz członkostwo przez naszą stronę internetową, Apple lub Google. Subskrypcje są przypisane do adresu e-mail, którego użyłeś podczas zakupu subskrypcji. Jeśli nie widzisz subskrypcji na swoim koncie, oznacza to, że nie masz subskrypcji powiązanej z adresem e-mail, na który jesteś obecnie zalogowany. Możliwe, że Twoja subskrypcja może być powiązana z innym adresem e-mail, i w takim przypadku będziesz musiał się wylogować, a następnie zalogować ponownie przy użyciu tego adresu e-mail, aby zobaczyć swoją subskrypcję."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1476
  override val HOW_TO_CANCEL_QUESTION = "Chcę anulować moją subskrypcję."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=99
  override val I_AGREE = "Zgadzam się"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1352
  override val I_HAVE_A_DIFFERENT_QUESTION = "Mam inne pytanie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1264
  override val I_HAVE_A_QUESTION_ABOUT = "Mam kolejne pytanie dotyczące:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1383
  override val I_STILL_NEED_HELP = "Nadal potrzebuję pomocy"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1387
  override val I_WANT_A_REFUND = "Chcę zwrotu pieniędzy."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3292
  override val INCLUDE_POSES_ANSWER = "<b>Joga</b>\n\nDzięki funkcji Ulubionych i Wykluczonych pozycji możesz \"polubić\" wybrane pozycje, co zwiększy prawdopodobieństwo, że pojawią się one w przyszłych praktykach. W pełnych ustawieniach, w sekcji <b>Praktyka</b>, stuknij <b>Zobacz pozycje</b>. Stąd możesz \"polubić\" pozycje, które chcesz częściej widzieć w swoich praktykach.\n\nW sekcji <b>Zobacz pozycje</b> możesz również \"nie lubić\" pozycji, a one zostaną wykluczone z przyszłych praktyk.\n\nNależy pamiętać, że funkcja Ulubionych i Wykluczonych pozycji jest dostępna tylko dla nowych typów praktyk: Vinyasa, Restorative, Yin, Gentle i Hatha. Starsze typy praktyk nie obsługują tej funkcji.\n\nNależy również pamiętać, że polubienie/niepolubienie pozycji wpłynie na różnorodność.\n\n<b>HIIT</b>\n\nTak! W sekcji Praktyka stuknij <b>Miks</b>. Następnie stuknij + po lewej stronie każdej części ciała, a pojawi się lista ćwiczeń. Stuknij w konkretne ćwiczenia, które chcesz wykluczyć z praktyki.\n\n<b>Przedporodowe, Barre</b>\n\nObecnie nie mamy tej funkcji, ale jest ona na naszej liście! Na razie, w aplikacji mobilnej, możesz pominąć dowolną pozycję, której nie lubisz, przesuwając w lewo, gdy się pojawi. W aplikacji internetowej kliknij strzałkę do przodu w dolnym lewym rogu ekranu."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3291
  override val INCLUDE_POSES_QUESTION = "Czy mogę uwzględnić konkretne pozycje w mojej praktyce?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=155
  override val INSTAGRAM = "Instagram"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=61
  override val INVALID_EMAIL_MESSAGE = "To nie wygląda na prawidłowy adres e-mail. Proszę spróbować ponownie."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=161
  override val KEEP_TIMELINE_VISIBLE = "Utrzymuj oś czasu widoczną"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=250
  override val LANGUAGE = "Język"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1426
  override val LATEST_PAYMENT = "Twoja ostatnia płatność była:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1396
  override val LEARN_MORE = "Dowiedz się więcej"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=168
  override val LENGTH = "Długość"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=254
  override val LESS = "Mniej"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1179
  override val LEVEL_ANSWER = "Ponieważ każdy jest inny, możesz spróbować przejść na wyższy poziom i zobaczyć, jak się z tym czujesz. Niektóre dni możesz chcieć zejść na niższy poziom, inne dni możesz mieć ochotę spróbować czegoś nowego! Najważniejsze, słuchaj informacji zwrotnych, które daje Ci Twoje ciało, i poruszaj się powoli i z kontrolą.\n\n<a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\">Społeczność na Facebooku</a>, dostępna przez stronę <b>Ustawienia</b> w aplikacji, to świetne źródło porad od innych użytkowników aplikacji!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1171
  override val LEVEL_QUESTION = "Kiedy powinienem przejść na wyższy poziom?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=344
  override val LIFETIME = "Dożywotni"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1465
  override val LIFETIME_ANSWER = "Nie. Obecnie tego nie oferujemy."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1464
  override val LIFETIME_QUESTION = "Czy mogę kupić subskrypcję na całe życie?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3945
  override val LIKE = "Polub"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3047
  override val LIKE_OR_DISLIKE_EXPLANATION = "Polub lub nie polub pozycje, aby poprawić swoje przyszłe praktyki"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3199
  override fun LIKED_DISLIKED_COUNT(p0: Any, p1: Any) = "${p0} Polubione, ${p1} Odrzucone"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2030
  override val LOCK_SCREEN_MEDIA_CONTROLS = "Sterowanie multimediami na ekranie blokady"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1729
  override val LOG_IN = "Zaloguj się"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1407
  override fun LOGGED_IN_AS(p0: Any) = "Jesteś zalogowany jako ${p0}."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=310
  override val LOGIN_ERROR = "Błąd logowania"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=141
  override val LOGOUT = "Wyloguj się"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=62
  override val LOGOUT_NO_INTERNET_MESSAGE = "Wygląda na to, że nie jesteś połączony z internetem. Proszę połącz się ponownie, aby zmienić konto."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1456
  override fun LOOK_SCHOOL_PAGE(p0: Any) = "Jeśli jesteś studentem lub nauczycielem, sprawdź naszą ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1227
  override val LOWER_VIDEO_QUALITY_ANSWER = "Możesz zmieniać różne typy wizualne! Rozpocznij praktykę, a następnie ją wstrzymaj. Stuknij w <b>ikonę koła zębatego</b> w prawym górnym rogu. Stuknij <b>Jakość wideo</b>. Powinieneś zobaczyć opcje dla wyższej i niższej jakości wideo. To ustawienie jest dostępne tylko w aplikacjach do jogi."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1217
  override val LOWER_VIDEO_QUALITY_QUESTION = "Filmy zajmują zbyt dużo miejsca w pamięci mojego telefonu."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2158
  override val MAKE_SURE_TO_VOTE_FOR_EVERY_OPTION = "Upewnij się, że zagłosujesz na każdą opcję!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1486
  override val MANAGE_EMAIL_PREFERENCES_ANSWER = "Staramy się nie wysyłać zbyt wielu e-maili, ale prosimy pamiętać, że e-maile są głównym sposobem informowania naszej społeczności o specjalnych promocjach i nowych funkcjach!\n\nMożesz kontrolować, czy jesteś zapisany lub wypisany z naszych e-maili, przechodząc do <b>Ustawienia</b>, a następnie przewijając w dół do <b>Otrzymuj e-maile promocyjne</b> i przełączając włączanie lub wyłączanie."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1488
  override val MANAGE_EMAIL_PREFERENCES_QUESTION = "Jak zarządzać preferencjami dotyczącymi e-maili?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1161
  override val MAXIMUM_VERBOSITY_ANSWER = "<b>Joga i Joga Prenatalna:</b>\n\nMożesz zwiększyć ilość mówienia, przesuwając widok ustawień w górę, a następnie stukając w <b>Instrukcja</b>. Stuknij <b>Pełna</b>, aby otrzymać największą ilość instrukcji, jaką oferujemy.\n\n<b>Meditacja:</b>\n\nAby otrzymać najwięcej instrukcji, ustaw <b>Ilość Przewodnictwa</b> na <b>Najwięcej</b> i ustaw <b>Najdłuższą Ciszę</b> na krótki czas, na przykład 30 sekund lub 1 minutę.\n\n<b>HIIT i Barre:</b>\nObecnie nie oferujemy możliwości zmiany ilości mówienia w HIIT i Barre."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1160
  override val MAXIMUM_VERBOSITY_QUESTION = "Chcę usłyszeć jak najwięcej instrukcji podczas wykonywania pozycji."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1661
  override val MEDITATION = "Medytacja"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1672
  override val MEDITATION_GOOGLE_FIT_DESCRIPTION = "Praktyka Medytacji"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1431
  override val MEMBERSHIP_DELAYED_START_ANSWER = "Nie. Subskrypcje rozpoczynają się natychmiast po zakupie.\n\nJeśli jesteś w okresie próbnym, możesz chcieć poczekać do jego zakończenia przed zakupem, jednak jeśli prowadzimy specjalną wyprzedaż, może to oznaczać przegapienie najlepszej ceny - wiemy, że to może być trudna decyzja!\n\nNiezależnie od tego, czy prowadzimy specjalną wyprzedaż, czy nie, nasza strona internetowa zazwyczaj oferuje najlepszą cenę w danym momencie, więc upewnij się, że odwiedzisz <a href=\"/purchase\">downdogapp.com/purchase</a>, gdy będziesz gotowy do zakupu!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1430
  override val MEMBERSHIP_DELAYED_START_QUESTION = "Czy mogę opóźnić datę rozpoczęcia subskrypcji?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=148
  override val MENU = "Menu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1163
  override val MINIMUM_VERBOSITY_ANSWER = "<b>Joga i Joga Prenatalna:</b>\n\nMożesz zmniejszyć ilość mówienia, przesuwając widok ustawień w górę, a następnie stukając w <b>Instrukcje</b>. Stuknij <b>Najmniej</b>, aby otrzymać najmniejszą ilość instrukcji, jaką oferujemy.\n\n<b>Meditacja:</b>\n\nAby otrzymać najmniejszą ilość instrukcji, jaką oferujemy, przesuń widok ustawień w górę i ustaw <b>Ilość Przewodnictwa</b> na <b>Najmniej</b>, a <b>Najdłuższą Ciszę</b> ustaw na dłuższy czas, na przykład 5 minut lub więcej!\n\n<b>HIIT i Barre:</b>\nObecnie nie oferujemy możliwości zmiany ilości mówienia w HIIT i Barre."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1162
  override val MINIMUM_VERBOSITY_QUESTION = "Chcę się wyłączyć i słyszeć jak najmniej instrukcji."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=309
  override fun MINUTES(p0: Any) = "${p0} Minuty"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1254
  override fun MINUTES_SHORT(p0: Any) = "${p0} min"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1610
  override val MINUTES_WITHOUT_NUMBER = "minuty"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1554
  override val MIRROR_VIDEO = "Lustrzane Odbicie Wideo"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3
  override val MISSING_APPLE_HEALTH_PERMISSIONS_MESSAGE = "Down Dog został dodany jako źródło w aplikacji Zdrowie. Aby jednak rozpocząć rejestrowanie praktyk, musisz włączyć uprawnienia do Treningów dla Down Dog w aplikacji Zdrowie."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1583
  override val MIX = "Mieszaj"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1510
  override val MONDAY = "Poniedziałek"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=519
  override val MONTH = "miesiąc"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=377
  override val MONTHLY = "miesięczny"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1290
  override val MONTHLY_CAPITALIZED = "Miesięczny"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1511
  override val MONTHLY_PRACTICES = "Miesięczne praktyki"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1516
  override fun MONTHLY_TIME(p0: Any) = "Czas ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1513
  override val MONTHLY_TIME_PRACTICED = "Miesięczny czas praktyki"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1482
  override val MONTHLY_TO_YEARLY_ANSWER = "Jeśli już zakupiłeś miesięczną subskrypcję, ale wolisz roczną subskrypcję, musisz podjąć kilka kroków, w zależności od tego, jak dokonałeś obecnego zakupu.\n\n<em>Jeśli zakupiłeś za pośrednictwem naszej <b>strony internetowej</b> lub <b>Google Play</b></em>:\n\nJeśli zakupiłeś obecną subskrypcję przez stronę internetową, przejdź do <b>Ustawienia</b>, a następnie <b>Subskrypcje</b>, aby anulować obecną subskrypcję. Jeśli zakupiłeś przez Google Play, możesz anulować obecną subskrypcję przez <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Sklep Google Play</a>. Po anulowaniu obecnej subskrypcji, możesz <a href=\"/purchase\">zakupić nową subskrypcję przez naszą stronę internetową</a>.\n\nProszę pamiętać, że jeśli zdecydujesz się anulować i ponownie zakupić, nie będziemy mogli zaoferować częściowego zwrotu. W niektórych ograniczonych przypadkach możesz być uprawniony do zwrotu obecnego zakupu - możesz sprawdzić swoją kwalifikację do zwrotu, klikając \"Chcę zwrot\" na stronie <a href=\"/support\">Wsparcie</a>. Jeśli jesteś uprawniony do zwrotu i pomyślnie złożyłeś wniosek oraz otrzymałeś potwierdzenie zwrotu na stronie \"Chcę zwrot\" na stronie <a href=\"/support\">Wsparcie</a>, wtedy twoja obecna subskrypcja zostanie automatycznie anulowana. Następnie możesz <a href=\"/purchase\">zakupić nową subskrypcję przez naszą stronę internetową</a>.\n\n<em>Jeśli zakupiłeś subskrypcję przez <b>Apple</b></em>:\n\nMusisz anulować subskrypcję <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">przez Apple App Store</a>. Proszę pamiętać, że nie jesteśmy w stanie wystawić zwrotów za zakupy dokonane przez Apple. Po anulowaniu obecnej subskrypcji przez Apple, możesz <a href=\"/purchase\">zakupić nową subskrypcję przez naszą stronę internetową</a>, która zazwyczaj ma najlepszą cenę!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1481
  override val MONTHLY_TO_YEARLY_QUESTION = "Kupiłem miesięczną subskrypcję, ale chcę przejść na roczną subskrypcję."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=276
  override val MORE = "Więcej"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=182
  override val MUSIC = "Muzyka"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1140
  override val MUSIC_VOLUME_VS_VOICE_ANSWER = "Gdy rozpoczniesz praktykę, jeśli dotkniesz ekranu i wstrzymasz swoją praktykę, możesz dostosować głośność muzyki i głosu za pomocą <b>suwaka miksowania Muzyka/Głos</b>.\n\nPo ustawieniu preferowanego stosunku Muzyka/Głos, możesz użyć swojego urządzenia do zwiększenia lub zmniejszenia ogólnej głośności."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1139
  override val MUSIC_VOLUME_VS_VOICE_QUESTION = "Nie słyszę głosu instruktora! Gdzie jest kontrola głośności?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=400
  override val MY_DATA = "Moje dane"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=429
  override val NEED_INTERNET_FOR_SONG_PREVIEW_MESSAGE = "Ups! Musisz być połączony z internetem, aby odtworzyć ten podgląd utworu."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3587
  override val NEW_PASSWORD = "Nowe Hasło"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=9
  override val NEXT = "Dalej"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=403
  override val NEXT_PAYMENT = "Następna płatność"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=483
  override fun NEXT_PAYMENT_SUBTEXT(p0: Any) = "Następna płatność: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1499
  override val NIDRA_AUDIO_ONLY_ANSWER = "Yoga Nidra jest dostępna <b>tylko w formie audio</b> - nie będzie wideo!\n\nYoga Nidra to głęboko relaksująca medytacja prowadzona. Możesz ją znaleźć w sekcji <b>Typ</b> praktyki, przewijając na sam dół. Wiele osób lubi ustawiać <b>Muzykę</b> na Dźwięki Natury, Ambient, Fale Mózgowe lub Fortepian i Smyczki w aplikacji... wypróbuj kilka i zobacz, który z nich wolisz!\n\nJeśli jesteś nowy w Yoga Nidra, zalecamy słuchanie jej z ustawionym <b>Typem Instrukcji</b> na <b>Pełne Wyjaśnienie</b> lub <b>Domyślne</b>.\n\nMożesz również użyć Yoga Nidra, aby zasnąć. Po wybraniu Yoga Nidra jako Typu praktyki, przejdź do <b>Wzmocnienie</b> i stuknij <b>Sen</b>!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1498
  override val NIDRA_AUDIO_ONLY_QUESTION = "Nie ma wideo z moją praktyką Yoga Nidra."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1472
  override val NO_EXCHANGE_FEES_ANSWER = "Nie pobieramy żadnych opłat za wymianę ani konwersję, ale Twoj bank może to zrobić, więc upewnij się, że to sprawdzisz!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1471
  override val NO_EXCHANGE_FEES_QUESTION = "Czy pobieracie opłaty za wymianę?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=160
  override val NO_FACEBOOK_EMAIL_MESSAGE = "Proszę zezwolić na dostęp do swojego adresu e-mail, aby zalogować się za pomocą Facebooka."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=162
  override val NO_HISTORY_TEXT = "Wygląda na to, że nie ukończyłeś jeszcze żadnych ćwiczeń. Przesuń palcem wstecz do ekranu głównego, aby rozpocząć swoją pierwszą praktykę!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=63
  override val NO_INTERNET_MESSAGE = "Mamy problem z komunikacją z naszymi serwerami. Proszę sprawdzić połączenie internetowe i spróbować ponownie."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1497
  override val NO_MUSIC_OFFLINE_ANSWER = "Ze względu na ograniczenia licencyjne, nasza muzyka nie będzie towarzyszyć zapisanym ulubionym, jeśli jesteś offline.\n\nJeśli chcesz odtwarzać własną muzykę, możesz to zrobić za pomocą innych aplikacji na swoim urządzeniu. Jednakże, mimo że wskazówki dźwiękowe są domyślnie ustawione na maksymalną głośność na telefonach i tabletach, czasami nie wystarcza to, aby przebić dźwięk pochodzący z Spotify/iTunes/itp.\n\nW takich przypadkach zalecamy użycie zewnętrznego głośnika do odtwarzania muzyki lub skorzystanie z wersji internetowej <a href=\"/web\">downdogapp.com/web</a> na laptopie lub komputerze stacjonarnym, z muzyką przyciszoną w tle."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1496
  override val NO_MUSIC_OFFLINE_QUESTION = "Jestem offline i moja zapisana ulubiona praktyka nie ma muzyki."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2551
  override val NO_OFFLINE_PRACTICES = "Nie pobrałeś jeszcze żadnych praktyk. Możesz pobrać praktyki z historii lub utworzyć nową tutaj!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1478
  override val NO_PARTIAL_REFUND_ANSWER = "Niestety, nie jesteśmy w stanie uwzględnić próśb o częściowe lub proporcjonalne zwroty.\n\nJeśli już zakupiłeś subskrypcję, ale chciałbyś inną subskrypcję, musisz podjąć kilka kroków, w zależności od tego, jak dokonałeś obecnego zakupu.\n\n<em>Jeśli zakupiłeś przez naszą <b>stronę internetową</b> lub <b>Google Play</b></em>:\n\nJeśli zakupiłeś obecną subskrypcję przez stronę internetową, przejdź do <b>Ustawienia</b>, a następnie <b>Subskrypcje</b>, aby anulować obecną subskrypcję. Jeśli zakupiłeś przez Google Play, możesz anulować obecną subskrypcję przez <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Sklep Google Play</a>. Po anulowaniu obecnej subskrypcji, możesz <a href=\"/purchase\">zakupić nową subskrypcję przez naszą stronę internetową</a>.\n\nProszę pamiętać, że jeśli zdecydujesz się anulować i ponownie zakupić, nie będziemy w stanie zaoferować częściowego zwrotu. W niektórych ograniczonych przypadkach możesz być uprawniony do zwrotu obecnego zakupu - możesz sprawdzić swoją kwalifikację do zwrotu, klikając \"Chcę zwrot\" na stronie <a href=\"/support\">Wsparcie</a>. Jeśli jesteś uprawniony do zwrotu i pomyślnie złożyłeś wniosek oraz otrzymałeś potwierdzenie zwrotu na stronie \"Chcę zwrot\" na stronie <a href=\"/support\">Wsparcie</a>, wtedy twoja obecna subskrypcja zostanie automatycznie anulowana. Następnie możesz <a href=\"/purchase\">zakupić nową subskrypcję przez naszą stronę internetową</a>.\n\n<em>Jeśli zakupiłeś subskrypcję przez <b>Apple</b></em>:\n\nMusisz anulować swoją subskrypcję <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">przez Apple App Store</a>. Proszę pamiętać, że nie jesteśmy w stanie uwzględnić próśb o zwrot za zakupy dokonane przez Apple. Po anulowaniu obecnej subskrypcji przez Apple, możesz <a href=\"/purchase\">zakupić nową subskrypcję przez naszą stronę internetową</a>, która zazwyczaj ma najlepszą cenę!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1477
  override val NO_PARTIAL_REFUND_QUESTION = "Czy mogę otrzymać częściowy zwrot?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=283
  override val NO_PAST_PURCHASES = "Brak wcześniejszych zakupów"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=163
  override val NO_PAST_PURCHASES_MESSAGE = "Wygląda na to, że nie dokonałeś żadnych wcześniejszych zakupów. Skontaktuj się z nami, jeśli uważasz, że to błąd."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1454
  override val NO_REFUND_PRACTICED = "Ta płatność nie podlega zwrotowi, ponieważ ukończyłeś praktykę po zakupie."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1455
  override fun NO_REFUND_TIME(p0: Any) = "Ta płatność nie podlega zwrotowi, ponieważ miała miejsce ponad ${p0} dni temu."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=164
  override val NO_SAVED_PRACTICES_TEXT = "Zapisz swoje ulubione praktyki, aby odtworzyć je później."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1224
  override val NO_SOUND_ANSWER = "Oto kilka kroków, które możesz podjąć, aby spróbować uzyskać dźwięk z aplikacji:\n\n• Czy upewniłeś się, że Twoje urządzenie nie jest wyciszone? Możesz to sprawdzić, odtwarzając muzykę lub dźwięk przez inną aplikację.\n• Czy sprawdziłeś, czy głośność w aplikacji jest włączona? Po rozpoczęciu praktyki możesz dostosować balans między muzyką a głosem, wstrzymując praktykę, a następnie regulując suwak na dole ekranu. Aby słyszeć zarówno muzykę, jak i głos, upewnij się, że jest ustawiony blisko środka!\n• Czy próbowałeś zamknąć i ponownie otworzyć aplikację?\n• Czy próbowałeś odinstalować i ponownie zainstalować aplikację?\n• Czy próbowałeś użyć wersji internetowej Down Dog (<a href=\"https://www.downdogapp.com/web\" target=\"_blank\">https://www.downdogapp.com/web</a>), aby sprawdzić, czy masz ten sam problem?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1214
  override val NO_SOUND_QUESTION = "Nie mam dźwięku."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=10
  override val NO_STRING = "Nie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1388
  override val NO_SUBSCRIPTIONS_SUPPORT_MESSAGE = "Na Twoim koncie nie ma aktywnych subskrypcji."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=284
  override val NONE = "Żaden"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1483
  override val NOT_FREE_ANSWER = "We wrześniu 2018 roku przeszliśmy na nowy model cenowy, w którym oferujemy ludziom krótki darmowy okres próbny z pełnym dostępem do wszystkich funkcji, a po jego zakończeniu wymagana jest subskrypcja. Ten model cenowy dotyczy wszystkich naszych aplikacji.\n\n<b>Metody zakupu</b>\n\n<a href=\"/purchase\">Zakup przez naszą stronę internetową</a> zazwyczaj zapewnia najlepszą cenę! Możesz dokonać zakupu na naszej stronie internetowej za pomocą <b>karty kredytowej</b> lub <b>PayPal</b>. Zakup przez naszą stronę internetową daje Ci dostęp do wszystkiego we wszystkich aplikacjach, tak jakbyś dokonał zakupu w aplikacji przez Apple lub Google.\n\nMożesz również dokonać zakupu w aplikacji przez Apple lub Google. Proszę zauważyć, że Apple i Google pobierają opłaty prowizyjne, dlatego cena w aplikacji zazwyczaj będzie wyższa niż na naszej stronie internetowej.\n\nW przypadku zakupów dokonanych poza Stanami Zjednoczonymi nie pobieramy żadnych opłat za wymianę walut, ale Twój bank może to zrobić, więc upewnij się, że sprawdzisz to z nimi!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1468
  override val NOT_FREE_QUESTION = "Myślałem, że aplikacja jest darmowa, dlaczego jestem proszony o zakup subskrypcji?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=285
  override val OK = "OK"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1686
  override fun ONLY_MIX_GROUP(p0: Any) = "Tylko ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=243
  override val OPEN_IN_AMAZON = "Otwórz w Amazon"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=216
  override val OPEN_IN_ITUNES = "Otwórz w iTunes"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=32
  override val OPEN_IN_SPOTIFY = "Otwórz w Spotify"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1257
  override fun OPEN_IN_X(p0: Any) = "Otwórz w ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3948
  override val OPEN_LINK = "Otwórz link"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2149
  override fun OPTION_X_OF_Y(p0: Any, p1: Any) = "Opcja ${p0} z ${p1}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=142
  override val OR = "lub"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1111
  override val OTHER = "Inne"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1059
  override val OTHER_APPS = "Inne aplikacje"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=194
  override val PACE = "Tempo"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=463
  override val PASSWORD = "Hasło"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=68
  override val PASSWORD_LENGTH_MESSAGE = "Twoje hasło powinno mieć co najmniej cztery znaki."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=445
  override val PASSWORDS_MUST_MATCH = "Hasła muszą się zgadzać"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3944
  override val PAUSE = "Wstrzymaj"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=339
  override val PAY_WITH = "Zapłać z"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=349
  override val PAY_WITH_PAYPAL = "Zapłać przez PayPal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=480
  override val PAYPAL = "PayPal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=347
  override val PAYPAL_AUTHORIZATION_ERROR_MESSAGE = "Wystąpił błąd podczas autoryzacji zakupu za pomocą PayPal. Spróbuj ponownie za kilka minut lub skontaktuj się z obsługą klienta."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1419
  override val PAYMENT_ALREADY_REFUNDED = "Ta płatność została już zwrócona."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=165
  override val PAYMENT_CONFIRMED_MESSAGE = "Płatność potwierdzona!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1474
  override val PAYMENT_METHODS_ANSWER = "Oto sposoby, w jakie możesz zakupić subskrypcję!\n\n1) Możesz zakupić przez naszą stronę internetową za pomocą <b>karty kredytowej</b> lub <b>PayPal</b>.\n\nZakup przez naszą stronę internetową daje Ci dostęp do wszystkiego we wszystkich aplikacjach, tak jakbyś zakupił w aplikacji przez Apple lub Google. Cena na naszej stronie internetowej jest zazwyczaj najlepsza, ponieważ nie ma opłat prowizyjnych Apple/Google.\n\n2) Możesz zakupić w aplikacji przez Apple lub Google.\n\nNależy pamiętać, że Apple i Google pobierają opłaty prowizyjne, dlatego cena w aplikacji będzie zazwyczaj wyższa niż na naszej stronie internetowej.\n\nW przypadku zakupów dokonanych poza Stanami Zjednoczonymi nie pobieramy żadnych opłat za wymianę walut, ale Twój bank może to zrobić, więc upewnij się, że sprawdzisz to z nimi!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1473
  override val PAYMENT_METHODS_QUESTION = "Jakie metody płatności akceptujecie?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=465
  override val PAYMENT_PLAN = "Planować"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=317
  override val PER_MONTH = "na miesiąc"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=318
  override val PER_YEAR = "rocznie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2539
  override val PILATES = "Pilates"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2549
  override val PILATES_GOOGLE_FIT_DESCRIPTION = "Trening Pilates"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3943
  override val PLAY = "Odtwórz"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=55
  override val PLAY_STORE_PRODUCT_PRICES_MESSAGE = "Błąd podczas pobierania cen produktów ze Sklepu Play"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=319
  override val PLAYLIST = "Lista odtwarzania"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=72
  override val PLAYLIST_TYPE_BUSY = "Mieliśmy problem ze zmianą typu Twojej playlisty. Spróbuj ponownie za kilka sekund."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=73
  override val PLAYLIST_TYPE_NO_INTERNET_MESSAGE = "Wygląda na to, że nie jesteś połączony z internetem. Proszę połącz się ponownie, aby zmienić rodzaje muzyki."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3049
  override fun POSE_DISLIKED_MESSAGE(p0: Any) = "Wykluczymy ${p0} z twoich przyszłych praktyk"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1199
  override val POSE_LIBRARY_ANSWER = "Obecnie nie oferujemy biblioteki pozycji, ale jest w trakcie opracowywania!  Bądźcie czujni!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1188
  override val POSE_LIBRARY_QUESTION = "Czy oferujecie bibliotekę pozycji, abym mógł dowiedzieć się więcej o każdej pozycji?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3048
  override fun POSE_LIKED_MESSAGE(p0: Any) = "Dodamy więcej ${p0} do twoich przyszłych praktyk"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1532
  override val POSE_LIST = "Lista Pozycji"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3008
  override val POSE_LIST_DESCRIPTION = "Przeglądaj wszystkie pozycje poniżej i oznacz, które z nich chciałbyś widzieć więcej lub mniej w przyszłych praktykach."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3252
  override val POSE_NAMES = "Nazwy Pozycji"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3071
  override val POSES = "Pozycje"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=286
  override val PRACTICE = "Ćwicz"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1275
  override val PRACTICE_FEEDBACK = "Informacje zwrotne dotyczące ćwiczeń"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=166
  override val PRACTICE_SAVED_CONFIRMATION = "Praktyka dodana do ulubionych!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1515
  override val PRACTICE_STREAK_NOT_CAPITALIZED = "Seria ćwiczeń"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1293
  override fun PRACTICES_IN_MONTH(p0: Any) = "Praktyki w ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=456
  override val PRENATAL = "Joga Prenatalna"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1200
  override val PRENATAL_ANSWER = "Tak! Mamy samodzielną aplikację Prenatal Yoga, która jest wliczona we wszystkie subskrypcje i którą warto sprawdzić! Możesz znaleźć Prenatal Yoga na <a href=\"https://play.google.com/store/apps/details?id=com.downdogapp.prenatal\" target=\"_blank\">Android</a> i <a href=\"https://apps.apple.com/us/app/prenatal-yoga-down-dog/id1504152442\" target=\"_blank\">iOS</a>, lub na <a href=\"https://prenatal.downdogapp.com/web\" target=\"_blank\">prenatal.downdogapp.com/web</a>. Ta aplikacja pozwoli Ci dostosować swoją praktykę do trymestru. Ma również wiele tych samych ulepszeń, które oferuje nasza główna aplikacja do jogi, plus kilka specjalnych, specyficznych dla ciąży."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1189
  override val PRENATAL_QUESTION = "Jestem w ciąży! Czy mogę wybrać opcję prenatalną?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1267
  override val PRENATAL_SHORT = "Prenatal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2554
  override fun PREPARING_VIDEO_PROGRESS(p0: Any) = "Przygotowywanie wideo... ${p0}% ukończone"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2569
  override val PREPARING_VIDEO_WARNING = "Przygotowujemy Twój film. Proszę, pozostaw aplikację otwartą, aż rozpocznie się pobieranie, lub wróć do aplikacji za kilka minut, aby zainicjować pobieranie."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1405
  override val PRICE_DIFFERENCE_ANSWER = "<a href=\"/purchase\">Zakup przez naszą stronę internetową</a> unika opłat prowizyjnych, które są często naliczane przez Apple lub Google, i zazwyczaj zapewnia najlepszą cenę! Możesz dokonać zakupu na naszej stronie internetowej za pomocą <b>karty kredytowej</b> lub <b>PayPal</b>. Zakup przez naszą stronę internetową daje dostęp do wszystkiego we wszystkich aplikacjach, tak jakbyś dokonał zakupu w aplikacji przez Apple lub Google. Możesz korzystać z subskrypcji internetowej na swoim komputerze, telefonie i tablecie.\n\nMożesz również zakupić subskrypcję w aplikacji przez Apple lub Google. Proszę pamiętać, że Apple i Google pobierają opłaty prowizyjne, dlatego cena w aplikacji zazwyczaj będzie wyższa niż na naszej stronie internetowej.\n\nW przypadku zakupów dokonanych poza Stanami Zjednoczonymi, nie naliczamy żadnych opłat za wymianę walut, ale Twój bank może to zrobić, więc upewnij się, że sprawdzisz to z nimi!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1404
  override val PRICE_DIFFERENCE_QUESTION = "Dlaczego ceny w aplikacji różnią się od cen na stronie internetowej? Czy członkostwa są różne?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=287
  override val PRIVACY_POLICY = "Polityka Prywatności"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=398
  override val PROMOTIONAL_EMAILS = "Otrzymuj e-maile promocyjne"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=351
  override fun RECEIPT_SENT_TO_EMAIL_MESSAGE(p0: Any) = "Paragon zostanie wysłany na ${p0}."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1461
  override val RECEIPTS_ANSWER = "Po zakupie subskrypcji wysyłamy paragon na adres e-mail powiązany z Twoją subskrypcją.\n\nNiestety, paragony nie mogą być wysyłane ponownie. Jeśli potrzebujesz znaleźć oryginalny paragon, zalecamy wyszukanie w swojej skrzynce odbiorczej tematu \"<b>PARAGON Z DOWN DOG</b>.\" Upewnij się, że sprawdziłeś folder ze spamem!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1460
  override val RECEIPTS_QUESTION = "Czy możesz przesłać mi paragon za zakup subskrypcji?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3799
  override val REDEEM = "Zrealizuj"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3798
  override fun REDEEM_GIFT_INSTRUCTIONS(p0: Any, p1: Any) = "Kliknij przycisk poniżej, aby uzyskać 1 rok darmowego dostępu do Down Dog! Prezent (kod ${p0}) zostanie przypisany do Twojego konta ${p1} od dnia, w którym zrealizujesz prezent."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3797
  override val REDEEM_GIFT_VIEW_TITLE = "Zrealizuj swoją kartę podarunkową Down Dog"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1222
  override val REFUND_ANSWER = "Jeśli zakupiłeś subskrypcję w internecie, możesz poprosić o zwrot pieniędzy na naszej stronie <a href=\"/support\">wsparcia</a>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1212
  override val REFUND_QUESTION = "Jak mogę otrzymać zwrot pieniędzy?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1424
  override val REFUNDED_ON_WAY = "Twój zwrot jest w drodze."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=626
  override val REMOVE_FROM_FAVORITES = "Usuń z ulubionych"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=625
  override val REMOVE_FROM_HISTORY = "Usuń z historii"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=663
  override val REMOVE_FROM_HISTORY_MESSAGE = "Czy na pewno chcesz usunąć tę praktykę ze swojej historii?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1206
  override val RENAME_FAVORITES_ANSWER = "Tak! Nazwanie indywidualnej praktyki to świetny sposób na zachowanie porządku i pomoże Ci zapamiętać, dlaczego ją uwielbiałeś!\n\nMożesz oznaczyć DOWOLNE praktyki znalezione w swojej Historii (niezależnie od tego, czy są ulubione, czy nie). Wystarczy dotknąć praktyki w swojej Historii i wybrać <b>Edytuj nazwę</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1194
  override val RENAME_FAVORITES_QUESTION = "Czy mogę nazwać moje ulubione praktyki, aby nie zapomnieć, która jest która?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3421
  override fun REQUIRED_EMAIL_DOMAIN_ALERT(p0: Any) = "Proszę zalogować się, używając adresu e-mail z domeną ${p0}!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1910
  override val RESET = "Zresetuj"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=154
  override fun RESET_PASSWORD_MESSAGE(p0: Any) = "Link do zresetowania hasła został wysłany na: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=167
  override val RESUME_PRACTICE = "Wznów ćwiczenia"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=169
  override val RESUME_PRACTICE_MESSAGE = "Czy chcesz wznowić swoją poprzednią praktykę?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2245
  override val RUNNING = "Bieganie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2255
  override val RUNNING_GOOGLE_FIT_DESCRIPTION = "Trening Biegowy Down Dog"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=66
  override val SAFARI_OR_MOBILE_BROWSER_WARNING_MESSAGE = "Aby uzyskać najlepsze wrażenia na telefonie lub tablecie, pobierz aplikację z App Store lub Play Store. Na komputerze stacjonarnym/laptopie używaj przeglądarki Chrome dla najbardziej niezawodnego odtwarzania."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1480
  override val SALE_PRICE_ANSWER = "Kiedy mamy wyprzedaż, musisz dokonać zakupu przez naszą stronę internetową, aby uzyskać obniżoną cenę.\n\nZakupy można dokonywać na naszej stronie internetowej za pomocą karty kredytowej lub PayPal. W przypadku transakcji międzynarodowych nie pobieramy opłat za wymianę walut, ale Twój bank może to zrobić, więc upewnij się, że sprawdzisz to u nich!\n\nJeśli już zakupiłeś subskrypcję i chciałbyś skorzystać z naszej specjalnej wyprzedaży, będziesz musiał podjąć kilka kroków, w zależności od tego, jak dokonałeś obecnego zakupu. Pamiętaj, że zakup subskrypcji wchodzi w życie natychmiast po zakupie i anuluje każdą obecną subskrypcję. Nie zostanie ona dodana na koniec Twojej obecnej subskrypcji.\n\n<em>Jeśli zakupiłeś przez naszą <b>stronę internetową</b> lub <b>Google Play</b></em>:\n\nJeśli zakupiłeś swoją obecną subskrypcję przez internet, przejdź do <b>Ustawienia</b>, a następnie <b>Subskrypcje</b>, aby anulować obecną subskrypcję. Jeśli zakupiłeś przez Google Play, możesz anulować swoją obecną subskrypcję przez <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Sklep Google Play</a>. Po anulowaniu obecnej subskrypcji możesz zakupić nową subskrypcję.\n\nPamiętaj, że jeśli zdecydujesz się anulować i ponownie zakupić, nie będziemy mogli zaoferować Ci częściowego zwrotu. W niektórych ograniczonych okolicznościach możesz być uprawniony do zwrotu obecnego zakupu - możesz sprawdzić swoją kwalifikację do zwrotu, klikając \"Chcę zwrot\" w <a href=\"/support\">Wsparcie</a>. Jeśli jesteś uprawniony do zwrotu i pomyślnie złożyłeś wniosek oraz otrzymałeś potwierdzenie zwrotu w \"Chcę zwrot\" w <a href=\"/support\">Wsparcie</a>, Twoja obecna subskrypcja zostanie automatycznie anulowana. Następnie możesz zakupić nową subskrypcję.\n\n<em>Jeśli zakupiłeś swoją subskrypcję przez <b>Apple</b></em>:\n\nBędziesz musiał anulować swoją subskrypcję <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">przez Apple App Store</a>. Pamiętaj, że nie jesteśmy w stanie zrealizować wniosków o zwrot za zakupy dokonane przez Apple. Po anulowaniu obecnej subskrypcji przez Apple, możesz zakupić nową subskrypcję, która zazwyczaj ma najlepszą cenę!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1479
  override val SALE_PRICE_QUESTION = "Dostałem e-mail o wyprzedaży! Jak mogę uzyskać cenę promocyjną?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=198
  override val SANSKRIT_POSE_NAMES = "Nazwy pozycji w sanskrycie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=454
  override val SAVE = "Zapisz"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=529
  override val SAVE_AND_UNLINK = "Zapisz i Odłącz"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1204
  override val SAVE_FOR_OFFLINE_ANSWER = "Tak! Istnieje kilka sposobów na zapisanie praktyki do użytku offline. Zauważ, że to działa tylko w aplikacjach mobilnych, a nie w wersji webowej.\n\n<em>Pobierz praktykę, której nigdy wcześniej nie robiłeś</em>\n\nNa ekranie głównym ustaw wszystkie preferencje, które chciałbyś mieć w praktyce, a następnie stuknij w <b>strzałkę w dół</b> na dole ekranu. Przeniesie Cię to do ekranu <b>Praktyka Offline</b>. Jeśli stukniesz w <b>Utwórz Praktykę Offline</b>, utworzy i zacznie pobierać nową praktykę z Twoimi bieżącymi ustawieniami.\n\n<em>Pobierz praktykę, którą już robiłeś</em>\n\nNa ekranie głównym stuknij w <b>ikonę zegara</b> na dole, aby zobaczyć swoją <b>Historię</b> praktyk. Stuknij w dowolną praktykę z tej listy, a następnie przewiń w dół i stuknij <b>Pobierz Praktykę</b>.\n\nZauważ, że to działa tylko dla praktyk w Twojej Historii, które pochodzą z aplikacji, której aktualnie używasz. Na przykład, jeśli wcześniej używałeś aplikacji Medytacja do wykonania praktyki oddechowej, a aktualnie używasz aplikacji Joga do przeglądania swojej Historii, praktyka oddechowa, którą wcześniej wykonałeś, pojawi się na liście Historii. Ponieważ ta wcześniejsza praktyka pochodzi z innej aplikacji niż ta, którą aktualnie przeglądasz, obok tej praktyki pojawi się mała niebieska ikona, wskazująca, że pochodzi ona z aplikacji Medytacja. Musisz przejść do aplikacji Medytacja i uzyskać dostęp do listy Historii stamtąd, aby mieć możliwość pobrania praktyki oddechowej.\n\n<em>Wyświetl pobraną praktykę</em>\n\nNa ekranie głównym stuknij w <b>strzałkę w dół</b> na dole ekranu. Przeniesie Cię to do ekranu <b>Praktyka Offline</b>. Każda praktyka, którą zobaczysz na ekranie, została pobrana i jest gotowa do odtworzenia bez połączenia z internetem!\n\nProszę zauważyć, że z powodu ograniczeń licencyjnych, nasza muzyka nie będzie towarzyszyć zapisanym ulubionym, gdy jesteś offline."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1192
  override val SAVE_FOR_OFFLINE_QUESTION = "Czy mogę używać Down Dog offline?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1205
  override val SAVE_TO_FAVORITES_ANSWER = "Tak!\n\n<em>Zapisz praktykę, którą właśnie ukończyłeś</em>\n\nJeśli chcesz zapisać praktykę zaraz po jej zakończeniu, stuknij <b>Dodaj do ulubionych</b> na stronie po zakończeniu praktyki, a zostanie ona zapisana w twoich <b>Ulubionych</b> i doda ikonę serca do twojej praktyki. Aby uzyskać dostęp do swoich <b>Ulubionych</b>, z strony <b>Historia</b> (dostępnej przez ikonę zegara na dole głównego ekranu), możesz kliknąć na dowolną praktykę w swojej Historii z ikoną serca lub przełączyć się z <b>Wszystkie</b>, aby zobaczyć tylko swoje <b>Ulubione</b>.\n\n<em>Zapisz wcześniejszą praktykę z twojej Historii</em>\n\nJeśli chcesz zapisać praktykę, którą wykonałeś wcześniej, przejdź do strony <b>Historia</b> (stuknij ikonę zegara na dole ekranu głównego). Gdy już tam będziesz, przewiń w dół i stuknij w praktykę, którą chcesz zapisać. Na dole zobaczysz słowa <b>Dodaj do ulubionych</b>. Naciśnięcie tego przycisku zapisze praktykę w twoich <b>Ulubionych</b> i doda ikonę serca do twojej praktyki. Aby uzyskać dostęp do swoich <b>Ulubionych</b>, z strony <b>Historia</b>, możesz kliknąć na dowolną praktykę w swojej Historii z ikoną serca lub przełączyć się z <b>Wszystkie</b>, aby zobaczyć tylko swoje <b>Ulubione</b>.\n\n<em>Ciekawostka!</em>\n\nMożesz oznaczyć DOWOLNE praktyki znalezione w swojej Historii (niezależnie od tego, czy są ulubione, czy nie). Wystarczy stuknąć w praktykę w swojej Historii i wybrać <b>Edytuj nazwę</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1193
  override val SAVE_TO_FAVORITES_QUESTION = "Czy istnieje sposób na zapisanie moich ulubionych ćwiczeń?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1458
  override val SCHOOL_MEMBERSHIPS = "Członkostwa Szkolne"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2150
  override val SCORE = "Ocena"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2151
  override val SCORE_HATE_IT = "1 (Nienawidzę tego)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2152
  override val SCORE_LOVE_IT = "5 (Uwielbiam to)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3951
  override val SEARCH = "Szukaj"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3108
  override val SEARCH_FOR_A_POSE = "Wyszukaj pozycję"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3286
  override val SEARCH_FOR_AN_EXERCISE = "Wyszukaj ćwiczenie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1601
  override val SEE_EXERCISES_ON_TIMELINE = "Zobacz ćwiczenia na osi czasu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1587
  override val SEE_POSES_ON_TIMELINE = "Zobacz pozycje na osi czasu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=270
  override val SELECT = "Wybierz"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=585
  override val SEND = "Wyślij"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=149
  override val SEND_FEEDBACK = "Prześlij opinię"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1406
  override val SENDING_FEEDBACK_FAILED = "Wysłanie opinii nie powiodło się"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2747
  override val SEQUENCE_LENGTH_INVALID = "Przepraszamy, ta długość ćwiczenia nie jest możliwa przy obecnych ustawieniach. Proszę wybrać inną długość."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=297
  override val SET_PASSWORD = "Ustaw hasło"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=430
  override val SETTINGS = "Ustawienia"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1177
  override val SETTINGS_FOR_BEGINNERS_ANSWER = "<b>Joga:</b>\n\n<em>Ustaw swój poziom</em>\n\nJeśli dopiero zaczynasz przygodę z jogą, zalecamy rozpoczęcie od poziomu <b>Beginner 1</b>, który znajdziesz w ustawieniach praktyki.\n\n<em>Wybierz rodzaj praktyki</em>\n\nDla łagodniejszej praktyki, która obejmuje zarówno pozycje stojące, jak i pozycje na podłodze, spróbuj rodzaju praktyki <b>Gentle</b>.\n\nDla relaksującej praktyki z samymi pozycjami na podłodze, spróbuj <b>Restorative</b> lub <b>Yin</b>, które pozwolą na najdłuższe utrzymywanie pozycji.\n\nDla szybszej, płynącej, bardziej energetycznej praktyki, spróbuj <b>Vinyasa</b>.\n\nJeśli chcesz mniej płynąć, pominąć chaturangi i pozwolić ciepłu budować się przez dłuższe utrzymywanie pozycji, spróbuj <b>Hatha</b>.\n\n<em>Poziom instrukcji</em>\n\nUstaw swój poziom <b>Instruction</b> na <b>Full</b>, aby otrzymać najbardziej szczegółowe instrukcje.\n\n<em>Ustaw prędkość przejść i długość utrzymywania pozycji</em>\n\nJeśli chcesz jeszcze bardziej spowolnić swoją praktykę, zalecamy dostosowanie prędkości przejść (<b>Transition Speed</b>) do <b>Slowest</b> i długości utrzymywania pozycji (<b>Hold Lengths</b>) do <b>Longest</b>. Należy pamiętać, że starsze rodzaje praktyk nie obsługują tych funkcji.\n\n<em>Wydłuż rozgrzewkę i schładzanie</em>\n\nDla rodzajów praktyki Vinyasa, Hatha i Gentle, dostosuj swoją <b>Warmup</b> i <b>Cooldown</b> do <b>Extended</b>. Należy pamiętać, że starsze rodzaje praktyk nie obsługują tych funkcji.\n\n<em>Lub i wyklucz pozycje</em>\nDla rodzajów praktyki Vinyasa, Hatha i Gentle, \"polub\" pozycje, aby widzieć je częściej w swojej praktyce, lub \"nie lub\" pozycje, aby nigdy więcej ich nie widzieć.\n\n\n<b>Joga prenatalna:</b>\n\nJeśli dopiero zaczynasz przygodę z jogą, zalecamy rozpoczęcie od poziomu <b>Beginner 1</b>, który znajdziesz, przesuwając w górę w widoku ustawień i szukając w ustawieniach praktyki.\n\nDla relaksującej praktyki, zalecamy rozpoczęcie od <b>Restorative</b>, która składa się z samych pozycji na podłodze i pozwala na najdłuższe utrzymywanie pozycji.\n\n\n<b>Meditacja:</b>\n\nJeśli dopiero zaczynasz przygodę z medytacją, zalecamy utrzymanie <b>Longest Silence</b> na dość krótkim poziomie - domyślnie jest to 2 minuty, ale możesz skrócić to nawet do 30 sekund, jeśli wolisz mieć mniej ciszy i więcej wskazówek. Możesz także ustawić ilość wskazówek (<b>Guidance Amount</b>) na <b>Most</b>, aby otrzymać najwięcej instrukcji, jakie oferujemy!\n\n\n<b>HIIT</b>\n\nNasze domyślne ustawienia to świetne miejsce na początek!\n\nJeśli HIIT jest zbyt wymagający na poziomie 1, spróbuj poziomu 0! Możesz także spróbować spędzać krótszy czas na każdym ćwiczeniu. Możesz to dostosować, przesuwając w górę w widoku ustawień i dostosowując swoje ustawienia w sekcji Praktyka, gdzie możesz dostosować długość ćwiczenia. Zdziwisz się, jak wielką różnicę mogą zrobić 5 lub 10 sekund! Możesz także skrócić długość całego treningu i wydłużyć czas każdej regeneracji między ćwiczeniami.\n\nOferujemy dwa rodzaje praktyki: <b>Rotation</b> i <b>Progression</b>. Wybierz <b>Progression</b>, aby przechodzić przez różne części ciała zawsze w tej samej kolejności, lub wybierz <b>Rotation</b>, aby przechodzić przez różne części ciała, ale mieszać kolejność w różnych praktykach!\n\n\n<b>Barre:</b>\n\nMożesz dostosować trudność, zmieniając długość swojego treningu. Doświadczeni sportowcy powinni zacząć od 15 lub 20 minut i zwiększać czas, jeśli chcą dodatkowego wyzwania. Jeśli jesteś początkujący, możesz zacząć od zaledwie 5 minut każdego dnia lub 10 minut co drugi dzień. Trzymaj się tego, a wkrótce będziesz gotowy na dłuższe treningi!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1169
  override val SETTINGS_FOR_BEGINNERS_QUESTION = "Nie wiem, od czego zacząć! Jakie ustawienia powinienem wybrać, aby uzyskać najlepsze doświadczenie?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1061
  override val SEVEN_MINUTE = "7 minut"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=150
  override val SHARE = "Udostępnij"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1246
  override val SHARE_PRACTICE_ANSWER = "Po zakończeniu ćwiczeń lub z poziomu <b>Historii</b> lub <b>Ulubionych</b>, stuknij <b>Udostępnij to ćwiczenie</b>, aby uzyskać link do udostępnienia tego ćwiczenia swoim znajomym.\n\nGdy Twoi znajomi klikną link, zostaną przeniesieni do aplikacji i otrzymają wyskakujące powiadomienie o zapisanym ćwiczeniu. Powinni stuknąć <b>Tak</b>, aby upewnić się, że zostanie ono zapisane w ich <b>Ulubionych</b>!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1245
  override val SHARE_PRACTICE_QUESTION = "Jak mogę udostępnić praktykę moim znajomym?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1181
  override val SHARE_THIS_PRACTICE = "Udostępnij tę praktykę"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1235
  override val SHARED_PRACTICE = "Wspólna Praktyka"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3257
  override val SHOW_EXERCISE_NAMES = "Pokaż nazwy ćwiczeń"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3343
  override val SHOW_LIKE_AND_EXCLUDE_BUTTONS = "Pokaż przyciski Lubię to i Wyklucz"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2085
  override val SHOW_OVERLAY = "Następne"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2082
  override val SHOW_POSE_NAME = "Pokaż Nazwy Pozycji"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1555
  override val SHOW_SUBTITLES = "Pokaż napisy"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1728
  override val SIGN_UP = "Zarejestruj się"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=64
  override val SIGN_UP_LOGIN = "Zarejestruj się / Zaloguj się"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=271
  override val SKIP = "Pomiń"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1173
  override val SLOWER_PACE_ANSWER = "<b>Joga:</b>\n\nIstnieje kilka ustawień, które możesz dostosować, aby spowolnić swoją praktykę - zalecamy eksperymentowanie ze wszystkimi!\n\n<em>Prędkość przejścia</em>\n\nPrzesuń w górę, aby zobaczyć pełne ustawienia. W sekcji <b>Timing</b> (Czas), stuknij w <b>Prędkość przejścia</b> i ustaw ją na <b>Najwolniejsza</b>, aby mieć najwięcej czasu na przejścia między jedną pozycją a drugą, a następnie stuknij <b>Wybierz</b>. Należy pamiętać, że starsze typy praktyk nie obsługują tej funkcji.\n\n<em>Długość trzymania pozycji</em>\n\nPrzesuń w górę, aby zobaczyć pełne ustawienia. W sekcji <b>Timing</b> (Czas), stuknij w <b>Długość trzymania pozycji</b> i ustaw ją na <b>Najdłuższa</b>, aby mieć najwięcej czasu w każdej pozycji, a następnie stuknij <b>Wybierz</b>. Należy pamiętać, że starsze typy praktyk nie obsługują tej funkcji.\n\n<em>Rozgrzewka</em> i <em>Schładzanie</em>\n\nUstaw swoją <b>Rozgrzewkę</b> i <b>Schładzanie</b> na <b>Rozszerzone</b>. Należy pamiętać, że starsze typy praktyk nie obsługują tych funkcji.\n\n<em>Poziom instrukcji</em>\n\nAby uzyskać najwięcej instrukcji i wskazówek, możesz również ustawić poziom <b>Instrukcji</b> na <b>Pełny</b>.\n\n<em>Typy praktyk</em>\n\nMożesz również spróbować ustawić typ swojej praktyki na <b>Łagodna</b> lub <b>Hatha</b> zamiast <b>Vinyasa</b>, aby pominąć przepływy vinyasa/chaturangi. Jeśli chcesz jeszcze bardziej spowolnić, ustaw typ swojej praktyki na <b>Yin</b> lub <b>Restoratywna</b>!\n\n<b>Joga prenatalna:</b>\n\nPrzesuń w górę w widoku ustawień i ustaw swoje <b>Tempo</b> na <b>Najwolniejsze</b>, aby spędzić najwięcej czasu w każdej pozycji. Aby uzyskać najwięcej instrukcji i wskazówek, możesz również ustawić poziom <b>Instrukcji</b> na <b>Pełne wyjaśnienie</b>.\n\n<b>HIIT:</b>\n\nMożesz zmienić czas spędzony na każdym ćwiczeniu. Przesuń w górę w widoku ustawień i w sekcji <b>Praktyka</b>, stuknij w <b>Długość ćwiczenia</b>. Możesz również dostosować czas odpoczynku między ćwiczeniami, stukając w <b>Odzyskiwanie</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1165
  override val SLOWER_PACE_QUESTION = "Jak mogę spowolnić tempo mojej praktyki?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=466
  override val SOCIAL = "Społeczność"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2086
  override val SOMETHING_WENT_WRONG = "Coś poszło nie tak"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1533
  override val SONG_LIST = "Lista Utworów"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=288
  override val SONGS_PLAYED = "Odtworzone utwory"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=272
  override val START = "Zacznij"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1600
  override val START_PRACTICE = "Rozpocznij Praktykę"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=89
  override val START_PRACTICE_NO_INTERNET_MESSAGE = "Wygląda na to, że nie jesteś połączony z internetem. Proszę połącz się ponownie, aby rozpocząć nową praktykę."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2090
  override val START_SHARED_PRACTICE = "Czy chcesz rozpocząć tę wspólną praktykę?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1507
  override val STAT_TYPE_SUBTITLE = "Co chciałbyś zobaczyć?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1506
  override val STAT_TYPE_TITLE = "Wybierz swoją statystykę"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1390
  override val STUDENTS_FREE_UNTIL_JANUARY_1_LONG = "Studenci i nauczyciele kwalifikują się do bezpłatnego członkostwa!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1268
  override val SUBJECT_COLON = "Temat:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=273
  override val SUBMIT = "Prześlij"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1266
  override val SUBMITTING = "Wysyłanie..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=477
  override val SUBSCRIPTION = "Subskrypcja"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1223
  override val SUBSCRIPTION_RENEWAL_PRICE_ANSWER = "Jeśli pozostawisz włączoną opcję automatycznego odnawiania, to tak! Jeśli wyłączysz automatyczne odnawianie, będziesz mieć możliwość ponownej subskrypcji po stawce dostępnej w momencie, gdy będziesz gotowy do ponownej subskrypcji. Proszę zauważyć, że w przypadku transakcji dokonanych przez Paypal, nie można ponownie włączyć automatycznego odnawiania po jego wyłączeniu."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1213
  override val SUBSCRIPTION_RENEWAL_PRICE_QUESTION = "Czy moja subskrypcja odnawia się w tej samej cenie, w jakiej ją zakupiłem?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1389
  override fun SUBSCRIPTIONS_SUPPORT_MESSAGE(p0: Any) = "Jesteś zalogowany jako ${p0}. Oto subskrypcje na Twoim koncie:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1288
  override val SUBTITLES_ANSWER = "Napisy są dostępne dla każdego języka, który oferujemy!\n\nW aplikacji mobilnej:\n1. Rozpocznij praktykę\n2. Dotknij ekranu, a następnie wybierz <b>ikonę koła zębatego</b>. Przełącz <b>Pokaż napisy</b> na pozycję <b>WŁĄCZ</b>\n\nW aplikacji internetowej:\n1. Rozpocznij praktykę\n2. Kliknij ikonę <b>cc</b> znajdującą się w prawym dolnym rogu ekranu, aby włączyć transkrypcje\n\nAby wyłączyć transkrypcje, po prostu kliknij ponownie <b>cc</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1287
  override val SUBTITLES_QUESTION = "Czy masz napisy/napisy dialogowe?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=452
  override val SUCCESS = "Sukces"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1509
  override val SUNDAY = "Niedziela"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=500
  override val SUPPORT = "Wsparcie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2333
  override val SUPPORT_MANAGE_EXPECTATIONS_TEXT = "Jesteśmy bardzo małą firmą i otrzymujemy tysiące wiadomości dziennie, więc nie możemy obiecać odpowiedzi, ale dołożymy wszelkich starań, aby odpowiedzieć jak najszybciej! Proszę zauważyć, że priorytetowo traktujemy wiadomości od płacących klientów."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1754
  override val SWIPE_DOWN_TO_START_PRACTICING = "Przesuń w dół, aby rozpocząć ćwiczenie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=262
  override val TAP_TO_BEGIN = "Stuknij, aby rozpocząć"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1260
  override val TECH_ISSUES = "Problemy techniczne"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=289
  override val TERMS_OF_USE = "Warunki użytkowania"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=303
  override val THANKS = "Dziękuję"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2157
  override val THANKS_FOR_FILLING_OUT_THE_SURVEY = "Dziękujemy za wypełnienie ankiety!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1265
  override val THIS_FORM_FIELD_IS_REQUIRED = "Proszę wypełnić to pole"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=615
  override val TIMELINE = "Oś czasu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2050
  override val TOGGLE_SHOW_MORE_SETTINGS = "Przełącz, aby pokazać więcej ustawień"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2590
  override val TOO_MANY_DOWNLOADS = "Osiągnąłeś maksymalną liczbę jednoczesnych pobrań. Poczekaj, aż jedno z nich się zakończy, i spróbuj ponownie."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1248
  override val TOTAL_PRACTICES = "Łączna liczba praktyk"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1523
  override val TOTAL_PRACTICES_CAPITALIZED = "Łączna Liczba Praktyk"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1524
  override val TOTAL_PRACTICES_NOT_CAPITALIZED = "Łączna liczba ćwiczeń"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1252
  override val TOTAL_TIME = "Całkowity czas"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1521
  override val TOTAL_TIME_CAPITALIZED = "Całkowity Czas"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1522
  override val TOTAL_TIME_NOT_CAPITALIZED = "Całkowity czas ćwiczeń"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1137
  override val TROUBLESHOOTING = "Rozwiązywanie problemów"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=251
  override val TRY_AGAIN = "Spróbuj ponownie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1155
  override val TURN_OFF_MUSIC_ANSWER = "Możesz wyłączyć muzykę w aplikacji, przesuwając widok ustawień w górę i stukając <b>Muzyka</b>, a następnie wybierając <b>Brak</b> jako typ muzyki!\n\nJeśli chcesz odtwarzać własną muzykę, możesz to zrobić za pomocą innych aplikacji na swoim urządzeniu. Jednakże, mimo że wskazówki dźwiękowe są domyślnie ustawione na maksymalną głośność na telefonach i tabletach, czasami nie jest to wystarczające, aby przebić dźwięk pochodzący z Spotify/iTunes/itp.\n\nW takich przypadkach zalecamy użycie zewnętrznego głośnika do odtwarzania muzyki lub korzystanie z wersji internetowej (https://www.downdogapp.com/web) na laptopie lub komputerze stacjonarnym, z muzyką przyciszoną w tle."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1154
  override val TURN_OFF_MUSIC_QUESTION = "Wolałbym słuchać własnej muzyki podczas ćwiczeń. Jak całkowicie wyłączyć muzykę?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2088
  override val UNABLE_TO_LOAD_PLAYBACK_URL = "Ups, nie udało nam się załadować wideo"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1276
  override val UNABLE_TO_OPEN_LINKED_PRACTICE = "Powiązana praktyka nie jest powiązana z tym kontem"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=998
  override val UNKNOWN_CAST_RECEIVER_NAME = "nieznane urządzenie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1641
  override val UNLINK_FROM_APPLE = "Odłącz od Apple"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1642
  override val UNLINK_FROM_APPLE_MESSAGE = "Ustaw hasło, aby odłączyć się od Apple."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=504
  override val UNLINK_FROM_FACEBOOK = "Odłącz od Facebooka"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=506
  override val UNLINK_FROM_FACEBOOK_MESSAGE = "Ustaw hasło, aby odłączyć się od Facebooka."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=505
  override val UNLINK_FROM_GOOGLE = "Odłącz od Google"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=507
  override val UNLINK_FROM_GOOGLE_MESSAGE = "Ustaw hasło, aby odłączyć się od Google."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1398
  override val UNLINK_GOOGLE_FACEBOOK_ANSWER = "1. Przejdź do <b>Ustawienia</b>. Na urządzeniach mobilnych możesz tam dotrzeć, stukając trzy poziome linie w prawym dolnym rogu ekranu. W wersji internetowej Ustawienia znajdują się w lewym pasku bocznym.\n2. W sekcji <b>Konto</b> stuknij <b>Odłącz od Google</b> (lub <b>Odłącz od Facebooka</b>) i wypełnij nowe hasło, którego chcesz używać, w polach Hasło i Potwierdź hasło.\n3. Stuknij <b>Zapisz</b>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1397
  override val UNLINK_GOOGLE_FACEBOOK_QUESTION = "Jak mogę odłączyć Google/Facebook i zamiast tego używać adresu e-mail i hasła?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=418
  override val UPDATE = "Aktualizuj"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1226
  override val VIDEO_ACCIDENTALLY_MIRRORED_ANSWER = "Jeśli cała Twoja praktyka jest odwrócona, upewnij się, że funkcja lustrzanego odbicia nie jest włączona! Oto jak to sprawdzić!\n\nW aplikacji mobilnej:\n1. Rozpocznij praktykę\n2. W prawym górnym rogu ekranu, stuknij <b>ikonę koła zębatego</b>. Przełącz <b>Mirror Video</b> na włączone lub wyłączone, aby odwrócić wyświetlacz\n\nW aplikacji internetowej:\n1. Rozpocznij praktykę\n2. W prawym dolnym rogu ekranu, kliknij <b>trzecią ikonę od lewej</b>, aby odwrócić wyświetlacz"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1216
  override val VIDEO_ACCIDENTALLY_MIRRORED_QUESTION = "Wideo jest odwrócone w stosunku do tego, co mówi głos."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1225
  override val VIDEO_FREEZING_ANSWER = "Oto kilka rzeczy, które możesz spróbować:\n\n1. Odinstaluj i ponownie zainstaluj aplikację\n\n2. Przełącz na niższą jakość wideo. Rozpocznij praktykę, a następnie wstrzymaj ją. Stuknij w <b>ikonę koła zębatego</b> w prawym górnym rogu. Stuknij <b>Jakość wideo</b>. Powinieneś zobaczyć opcje dla wyższej i niższej jakości wideo. To ustawienie jest dostępne tylko w aplikacjach do jogi.\n\n3. Tylko w sieci: Spróbuj innej przeglądarki. Down Dog działa najlepiej z Safari, Firefox i Chrome."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1215
  override val VIDEO_FREEZING_QUESTION = "Mój ekran zamarzł w połowie praktyki."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1201
  override val VIDEO_MODEL_ANSWER = "<b>Joga, Prenatalna, Barre</b>\n\nObecnie mamy tylko jeden model dla każdej z naszych aplikacji. W miarę naszego rozwoju, chcielibyśmy móc dodać więcej opcji dla Ciebie!\n\n<b>HIIT</b>\n\nObecnie oferujemy dwa modele w aplikacji HIIT!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1190
  override val VIDEO_MODEL_QUESTION = "Czy mogę obejrzeć więcej niż jeden model na wideo?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=670
  override val VIDEO_QUALITY = "Jakość wideo"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2558
  override val VIEW_OFFLINE_PRACTICE = "Zobacz ćwiczenia offline"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1491
  override val VIEW_PLAYLIST_ANSWER = "Po zakończeniu praktyki lub z praktyki na stronie <b>Historia</b>, stuknij <b>Lista utworów</b>, aby zobaczyć listę odtwarzania utworów, które były odtwarzane podczas Twojej praktyki!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1490
  override val VIEW_PLAYLIST_QUESTION = "Jakie piosenki były odtwarzane podczas mojej praktyki?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3109
  override val VIEW_POSES = "Zobacz Pozycje"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=75
  override val VISUAL_TYPE_NO_INTERNET_MESSAGE = "Wygląda na to, że nie jesteś połączony z internetem. Proszę połącz się ponownie, aby zmienić typy wizualne."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=290
  override val VOICE = "Głos"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2159
  override val VOICE_ACTOR_NON_ENGLISH_SURVEY_INTRO = "Dodajemy nowych lektorów do aplikacji i chcemy poznać Twoją opinię! Oceń, jak podobają Ci się poniższe głosy, w skali od 1 do 5. Prosimy, abyś zignorował wszelkie problemy techniczne/jakości dźwięku i skupił się na samym głosie oraz na tym, jak naturalnie brzmi tłumaczenie!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2154
  override val VOICE_ACTOR_SURVEY_INTRO = "Dodajemy nowych lektorów do aplikacji i chcemy poznać Twoją opinię! Powiedz nam, jak podobają Ci się poszczególne głosy poniżej, oceniając je od 1 do 5. Prosimy, zignoruj wszelkie problemy techniczne/jakość dźwięku i skup się na samym głosie!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1423
  override val WANT_REFUND_CONFIRMATION = "Czy chcesz, aby ta płatność została zwrócona? Twoja subskrypcja zostanie anulowana i natychmiast stracisz dostęp."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1508
  override val WEEK_START_TITLE = "Kiedy powinien zaczynać się Twój tydzień?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1518
  override val WEEKLY_GOAL = "Cotygodniowy cel"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1504
  override val WEEKLY_GOAL_SELECTOR_TITLE = "Ustal tygodniowy cel"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1505
  override val WEEKLY_GOAL_SUBTITLE = "Ile praktyk zamierzasz wykonywać każdego tygodnia?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=569
  override val WHATS_UP = "Co słychać?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1256
  override fun X_PERCENT_COMPLETE(p0: Any) = "${p0}% Ukończono"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=378
  override val YEARLY = "rocznie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1289
  override val YEARLY_CAPITALIZED = "Rocznie"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1731
  override val YES_SIGN_UP = "Tak, Zarejestruj się"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=291
  override val YES_STRING = "Tak"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1060
  override val YOGA = "Joga"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=501
  override val YOGA_FOR_BEGINNERS = "Joga dla Początkujących"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=757
  override val YOGA_GOOGLE_FIT_DESCRIPTION = "Praktyka Jogi Down Dog"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1493
  override val YOGA_NIDRA_INFO_ANSWER = "Yoga Nidra to głęboko relaksująca medytacja prowadzona. W głównej aplikacji do jogi znajdziesz ją pod sekcją <b>Typ</b>.\n\nUwaga: <b>Yoga Nidra jest tylko audio</b> - nie będzie wideo.\n\nWiele osób lubi ustawiać <b>Muzykę</b> na Dźwięki Natury, Ambient, Fale Mózgowe lub Fortepian i Smyczki w aplikacji. Wypróbuj kilka i zobacz, który z nich wolisz!\n\nJeśli jesteś nowy w Yoga Nidra, zalecamy słuchanie jej z ustawionym <b>Typem Instrukcji</b> na <b>Pełne Wyjaśnienie</b> lub <b>Domyślne</b>.\n\nMożesz również użyć Yoga Nidra, aby zasnąć! Po wybraniu Yoga Nidra jako Typu praktyki, przejdź do <b>Wzmocnienia</b> i ustaw swoje wzmocnienie na <b>Sen</b>!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1492
  override val YOGA_NIDRA_INFO_QUESTION = "Czym jest Yoga Nidra?"
}
